// This file is auto-generated by @hey-api/openapi-ts

import { type Client, formDataBodySerializer, type Options as Options2, type TDataShape } from './client';
import { client } from './client.gen';
import type { AddBatchFilesData, AddBatchFilesErrors, AddBatchFilesResponses, AddMembersData, AddMembersResponses, AdjustUserGroupMemberSkillData, AdjustUserGroupMemberSkillResponses, ArchiveAssetMetadataKeyData, ArchiveAssetMetadataKeyErrors, ArchiveAssetMetadataKeyResponses, ArchiveEvaluationProfileData, ArchiveEvaluationProfileResponses, ArchiveOutputNameData, ArchiveOutputNameResponses, AssignPlatformAdminRoleData, AssignPlatformAdminRoleResponses, AssignRolesToUsersData, AssignRolesToUsersResponses, AssignSpecificTaskToUserData, AssignSpecificTaskToUserResponses, AssignTaskToUserData, AssignTaskToUserResponses, AssignUserToGroupData, AssignUserToGroupResponses, AttachAiNodeAssetData, AttachAiNodeAssetResponses, BulkCancelWorkItemsData, BulkCancelWorkItemsErrors, BulkCancelWorkItemsResponses, BulkReopenWorkItemsData, BulkReopenWorkItemsErrors, BulkReopenWorkItemsResponses, BulkUnassignTasksData, BulkUnassignTasksErrors, BulkUnassignTasksResponses, BulkUnassignUsersFromGroupData, BulkUnassignUsersFromGroupResponses, CompleteUserTaskData, CompleteUserTaskResponses, CountAssetsData, CountAssetsResponses, CountDatasetsData, CountDatasetsResponses, CountMembersData, CountMembersResponses, CountPlatformProjectsData, CountPlatformProjectsResponses, CountTasksData, CountTasksResponses, CountUserGroupMembersData, CountUserGroupMembersResponses, CountWorkItemsData, CountWorkItemsResponses, CreateAiAssetData, CreateAiAssetErrors, CreateAiAssetResponses, CreateAiNodeData, CreateAiNodeResponses, CreateAiNodeVersionData, CreateAiNodeVersionResponses, CreateApiKeyData, CreateApiKeyResponses, CreateAssetData, CreateAssetMetadataKeyData, CreateAssetMetadataKeyErrors, CreateAssetMetadataKeyResponses, CreateAssetResponses, CreateAttributesData, CreateAttributesResponses, CreateAttributeVersionData, CreateAttributeVersionResponses, CreateBatchData, CreateBatchErrors, CreateBatchResponses, CreateBucketMountDiscoveryData, CreateBucketMountDiscoveryResponses, CreateCompanyData, CreateCompanyResponses, CreateDatasetData, CreateDatasetResponses, CreateEvalExpressionData, CreateEvalExpressionErrors, CreateEvalExpressionResponses, CreateEvaluationProfileData, CreateEvaluationProfileResponses, CreateEvaluationProfileVersionData, CreateEvaluationProfileVersionResponses, CreateFormData, CreateFormResponses, CreateFormVersionData, CreateFormVersionResponses, CreateGuidelineAssetData, CreateGuidelineAssetResponses, CreateGuidelineData, CreateGuidelineResponses, CreateGuidelineVersionData, CreateGuidelineVersionResponses, CreateJobData, CreateJobResponses, CreateLabelClassesData, CreateLabelClassesResponses, CreateLabelClassVersionData, CreateLabelClassVersionResponses, CreateOutputNameData, CreateOutputNameLinkData, CreateOutputNameLinkResponses, CreateOutputNameResponses, CreateProjectData, CreateProjectResponses, CreateQcSamplingPolicyData, CreateQcSamplingPolicyErrors, CreateQcSamplingPolicyResponses, CreateServiceAccountV2Data, CreateServiceAccountV2Responses, CreateSowConfigData, CreateSowConfigResponses, CreateSpaceData, CreateSpaceResponses, CreateSplitData, CreateSplitResponses, CreateTaxonomyData, CreateTaxonomyResponses, CreateTaxonomyVersionData, CreateTaxonomyVersionResponses, CreateUserGroupData, CreateUserGroupResponses, CreateWebhookData, CreateWebhookResponses, CreateWorkflowData, CreateWorkflowResponses, CreateWorkItemMetadataFormData, CreateWorkItemMetadataFormResponses, DeleteAiNodeTagData, DeleteAiNodeTagResponses, DeleteAssetData, DeleteAssetErrors, DeleteAssetImportData, DeleteAssetImportResponses, DeleteAssetResponses, DeleteCompanyData, DeleteCompanyResponses, DeleteDatasetData, DeleteDatasetResponses, DeleteFormData, DeleteFormResponses, DeleteGuidelineData, DeleteGuidelineResponses, DeleteProjectData, DeleteProjectResponses, DeleteServiceAccountData, DeleteServiceAccountResponses, DeleteSpaceData, DeleteSpaceResponses, DeleteTaxonomyData, DeleteTaxonomyResponses, DeleteWebhookData, DeleteWebhookResponses, DeprecateAiNodeData, DeprecateAiNodeResponses, DetachAiNodeAssetData, DetachAiNodeAssetResponses, ForceCompleteTaskData, ForceCompleteTaskErrors, ForceCompleteTaskResponses, GetAiAssetByIdData, GetAiAssetByIdErrors, GetAiAssetByIdResponses, GetAiNodeData, GetAiNodeResponses, GetAnalyticsDashboardUrlData, GetAnalyticsDashboardUrlErrors, GetAnalyticsDashboardUrlResponses, GetAnnotationConfigData, GetAnnotationConfigResponses, GetApiKeyData, GetApiKeyResponses, GetAssetByIdData, GetAssetByIdResponses, GetAssetImportData, GetAssetImportResponses, GetAssetMetadataValuesData, GetAssetMetadataValuesResponses, GetAttributeData, GetAttributeResponses, GetAttributeVersionData, GetAttributeVersionResponses, GetBatchByIdData, GetBatchByIdErrors, GetBatchByIdResponses, GetBatchCountData, GetBatchCountErrors, GetBatchCountResponses, GetBatchPrioritizationData, GetBatchPrioritizationErrors, GetBatchPrioritizationResponses, GetBucketMountData, GetBucketMountDiscoveryData, GetBucketMountDiscoveryResponses, GetBucketMountResponses, GetBulkForceCompleteJobData, GetBulkForceCompleteJobErrors, GetBulkForceCompleteJobResponses, GetClassLayoutData, GetClassLayoutResponses, GetCompanyByIdData, GetCompanyByIdResponses, GetEvalExpressionData, GetEvalExpressionErrors, GetEvalExpressionResponses, GetEvaluationProfileData, GetEvaluationProfileResponses, GetEvaluationProfileVersionData, GetEvaluationProfileVersionResponses, GetFormData, GetFormDetailsFromAnnotationData, GetFormDetailsFromAnnotationResponses, GetFormResponses, GetFormVersionData, GetFormVersionResponses, GetGuidelineData, GetGuidelineResponses, GetGuidelineUploadUrlsData, GetGuidelineUploadUrlsResponses, GetGuidelineVersionData, GetGuidelineVersionResponses, GetLabelClassData, GetLabelClassResponses, GetLabelClassVersionData, GetLabelClassVersionResponses, GetMemberData, GetMemberResponses, GetOutputNameData, GetOutputNameResponses, GetProjectByIdData, GetProjectByIdResponses, GetProjectCollaboratorsData, GetProjectCollaboratorsResponses, GetProjectPriorityConfigData, GetProjectPriorityConfigErrors, GetProjectPriorityConfigResponses, GetProjectSettingData, GetProjectSettingResponses, GetProjectWorkflowSettingData, GetProjectWorkflowSettingResponses, GetQcSamplingPolicyData, GetQcSamplingPolicyErrors, GetQcSamplingPolicyResponses, GetServiceAccountData, GetServiceAccountResponses, GetSignedUrlsData, GetSignedUrlsResponses, GetSowConfigData, GetSowConfigResponses, GetSowConfigSlaAlertConfigData, GetSowConfigSlaAlertConfigErrors, GetSowConfigSlaAlertConfigResponses, GetSpaceByIdData, GetSpaceByIdResponses, GetSpaceSettingData, GetSpaceSettingResponses, GetSplitData, GetSplitResponses, GetSystemTaxonomyData, GetSystemTaxonomyResponses, GetTaskByIdData, GetTaskByIdResponses, GetTaskDraftData, GetTaskDraftErrors, GetTaskDraftResponses, GetTaskViewData, GetTaskViewErrors, GetTaskViewResponses, GetTaxonomyData, GetTaxonomyResponses, GetTaxonomyVersionData, GetTaxonomyVersionResponses, GetUploadUrlsData, GetUploadUrlsResponses, GetUserGroupMemberData, GetUserGroupMemberLevelHistoryData, GetUserGroupMemberLevelHistoryResponses, GetUserGroupMemberResponses, GetWorkflowData, GetWorkflowDefinitionByVersionData, GetWorkflowDefinitionByVersionErrors, GetWorkflowDefinitionByVersionResponses, GetWorkflowResponses, GetWorkflowTemplateData, GetWorkflowTemplateResponses, GetWorkItemAnnotationData, GetWorkItemAnnotationErrors, GetWorkItemAnnotationResponses, GetWorkItemData, GetWorkItemErrors, GetWorkItemExecutionData, GetWorkItemExecutionErrors, GetWorkItemExecutionResponses, GetWorkItemInferenceData, GetWorkItemInferenceResponses, GetWorkItemMetadataFormData, GetWorkItemMetadataFormResponses, GetWorkItemResponses, GetWorkItemsByQueryData, GetWorkItemsByQueryResponses, HealthCheckData, HealthCheckErrors, HealthCheckResponses, ImportGuidelineData, ImportGuidelineResponses, InternalCancelWorkItemData, InternalCancelWorkItemErrors, InternalCancelWorkItemResponses, InternalCreateExportData, InternalCreateExportErrors, InternalCreateExportResponses, InternalDeleteExportData, InternalDeleteExportErrors, InternalDeleteExportResponses, InternalDeleteWorkItemData, InternalDeleteWorkItemErrors, InternalDeleteWorkItemResponses, InternalGetExportData, InternalGetExportErrors, InternalGetExportResponses, InternalListExportsData, InternalListExportsErrors, InternalListExportsResponses, InternalReopenWorkItemData, InternalReopenWorkItemErrors, InternalReopenWorkItemResponses, JwtUserLoginData, JwtUserLoginResponses, LaunchGuidelineGenerationData, LaunchGuidelineGenerationResponses, ListAiAssetsData, ListAiAssetsResponses, ListAiNodesData, ListAiNodesResponses, ListAiNodeTagsData, ListAiNodeTagsResponses, ListAllWorkflowVersionsData, ListAllWorkflowVersionsResponses, ListAnnotationsByQueryData, ListAnnotationsByQueryResponses, ListApiKeysData, ListApiKeysResponses, ListAssetImportsData, ListAssetImportsResponses, ListAssetMetadataKeysData, ListAssetMetadataKeysResponses, ListAssetsData, ListAssetsResponses, ListAssignableTasksForUserData, ListAssignableTasksForUserResponses, ListAttributesData, ListAttributesResponses, ListAttributeVersionsData, ListAttributeVersionsResponses, ListBatchesData, ListBatchesErrors, ListBatchesResponses, ListBlockCatalogData, ListBlockCatalogResponses, ListBucketMountDiscoveriesData, ListBucketMountDiscoveriesResponses, ListBucketMountDiscoveryObjectsData, ListBucketMountDiscoveryObjectsResponses, ListCompaniesData, ListCompaniesResponses, ListDatasetsData, ListDatasetsResponses, ListEvalExpressionsData, ListEvalExpressionsResponses, ListEvaluationProfilesData, ListEvaluationProfilesResponses, ListEvaluationProfileVersionsData, ListEvaluationProfileVersionsResponses, ListFormsData, ListFormsResponses, ListFormVersionsData, ListFormVersionsResponses, ListGuidelineAssetDocumentsData, ListGuidelineAssetDocumentsResponses, ListGuidelinesData, ListGuidelinesResponses, ListGuidelineVersionsData, ListGuidelineVersionsResponses, ListJobsData, ListJobsResponses, ListLabelClassesData, ListLabelClassesResponses, ListLabelClassVersionsData, ListLabelClassVersionsResponses, ListMembersData, ListMembersResponses, ListOutputNamesData, ListOutputNamesResponses, ListPermissionsData, ListPermissionsResponses, ListPlatformAdminsData, ListPlatformAdminsResponses, ListPlatformProjectsData, ListPlatformProjectsResponses, ListProjectsData, ListProjectsResponses, ListServiceAccountsData, ListServiceAccountsResponses, ListSpacesData, ListSpacesResponses, ListSplitsData, ListSplitsErrors, ListSplitsResponses, ListSystemTaxonomiesData, ListSystemTaxonomiesResponses, ListTasksData, ListTasksResponses, ListTaxonomiesData, ListTaxonomiesResponses, ListTaxonomyVersionsData, ListTaxonomyVersionsResponses, ListUserGroupMembersData, ListUserGroupMembersResponses, ListUserGroupsData, ListUserGroupsResponses, ListUserRolesData, ListUserRolesResponses, ListWebhooksData, ListWebhooksResponses, ListWorkflowsData, ListWorkflowsResponses, ListWorkflowTemplatesData, ListWorkflowTemplatesResponses, ListWorkflowVersionsData, ListWorkflowVersionsErrors, ListWorkflowVersionsResponses, ListWorkItemsData, ListWorkItemsResponses, ListWorkItemsStatsData, ListWorkItemsStatsResponses, LoginUserData, LoginUserResponses, LogoutUserData, LogoutUserResponses, MoveAssetData, MoveAssetErrors, MoveAssetResponses, PatchAiAssetData, PatchAiAssetErrors, PatchAiAssetResponses, PatchAiNodeData, PatchAiNodeResponses, ProcessConsensusSamplerData, ProcessConsensusSamplerResponses, ProcessRandomSamplerData, ProcessRandomSamplerResponses, ProjectWorkflowSwitchData, ProjectWorkflowSwitchErrors, ProjectWorkflowSwitchResponses, PublishAiNodeData, PublishAiNodeResponses, PublishWorkflowData, PublishWorkflowErrors, PublishWorkflowResponses, PurgeAssetData, PurgeAssetErrors, PurgeAssetResponses, ReactivateUserInGroupData, ReactivateUserInGroupResponses, RecordTaskValidationAckData, RecordTaskValidationAckErrors, RecordTaskValidationAckResponses, RedirectInviteData, RedirectInviteErrors, RedirectInviteResponses, RegenerateApiKeyData, RegenerateApiKeyErrors, RegenerateApiKeyResponses, RemoveMembersData, RemoveMembersResponses, RequestMagicLinkData, RequestMagicLinkResponses, RespondToInterruptionOfferData, RespondToInterruptionOfferResponses, RestoreAssetData, RestoreAssetErrors, RestoreAssetResponses, RevokeApiKeyData, RevokeApiKeyErrors, RevokeApiKeyResponses, RevokePlatformAdminRoleData, RevokePlatformAdminRoleResponses, RotateServiceAccountApiKeyData, RotateServiceAccountApiKeyErrors, RotateServiceAccountApiKeyResponses, SaveTaskDraftData, SaveTaskDraftErrors, SaveTaskDraftResponses, SetAiNodeTagData, SetAiNodeTagResponses, SetAttributeVersionCurrentData, SetAttributeVersionCurrentResponses, SetFormVersionCurrentData, SetFormVersionCurrentResponses, SetGuidelineVersionCurrentData, SetGuidelineVersionCurrentResponses, SetLabelClassVersionCurrentData, SetLabelClassVersionCurrentResponses, SetTaxonomyVersionCurrentData, SetTaxonomyVersionCurrentResponses, StartAssetImportData, StartAssetImportResponses, StatusUpdateTasksData, StatusUpdateTasksResponses, StreamNotificationsData, StreamNotificationsErrors, StreamNotificationsResponses, SubmitBulkForceCompleteJobData, SubmitBulkForceCompleteJobErrors, SubmitBulkForceCompleteJobResponses, TakeoverTaskData, TakeoverTaskErrors, TakeoverTaskResponses, TestEvalExpressionData, TestEvalExpressionErrors, TestEvalExpressionResponses, TriggerAssetVpgData, TriggerAssetVpgErrors, TriggerAssetVpgResponses, UnassignTasksData, UnassignTasksResponses, UpdateAnnotationData, UpdateAnnotationResponses, UpdateAttributeData, UpdateAttributeResponses, UpdateBatchData, UpdateBatchErrors, UpdateBatchResponses, UpdateCompanyData, UpdateCompanyResponses, UpdateEvalExpressionData, UpdateEvalExpressionErrors, UpdateEvalExpressionResponses, UpdateEvaluationProfileData, UpdateEvaluationProfileResponses, UpdateFormData, UpdateFormResponses, UpdateFormVersionData, UpdateFormVersionResponses, UpdateGuidelineData, UpdateGuidelineResponses, UpdateGuidelineVersionData, UpdateGuidelineVersionResponses, UpdateLabelClassData, UpdateLabelClassResponses, UpdateOutputNameData, UpdateOutputNameResponses, UpdateProjectData, UpdateProjectResponses, UpdateQcSamplingPolicyData, UpdateQcSamplingPolicyErrors, UpdateQcSamplingPolicyResponses, UpdateRolesFromUsersData, UpdateRolesFromUsersResponses, UpdateSowConfigData, UpdateSowConfigResponses, UpdateSpaceData, UpdateSpaceResponses, UpdateTaxonomyData, UpdateTaxonomyResponses, UpdateTaxonomyVersionData, UpdateTaxonomyVersionResponses, UpdateUserGroupData, UpdateUserGroupMemberData, UpdateUserGroupMemberResponses, UpdateUserGroupResponses, UpdateWebhookData, UpdateWebhookResponses, UpdateWorkflowData, UpdateWorkflowDefinitionData, UpdateWorkflowDefinitionErrors, UpdateWorkflowDefinitionResponses, UpdateWorkflowResponses, UpsertBatchActivationData, UpsertBatchActivationErrors, UpsertBatchActivationResponses, UpsertBatchPrioritizationData, UpsertBatchPrioritizationErrors, UpsertBatchPrioritizationResponses, UpsertBucketMountData, UpsertBucketMountResponses, UpsertClassLayoutData, UpsertClassLayoutResponses, UpsertProjectPriorityConfigData, UpsertProjectPriorityConfigErrors, UpsertProjectPriorityConfigResponses, UpsertProjectSettingData, UpsertProjectSettingResponses, UpsertProjectWorkflowSettingData, UpsertProjectWorkflowSettingResponses, UpsertSowConfigSlaAlertConfigData, UpsertSowConfigSlaAlertConfigErrors, UpsertSowConfigSlaAlertConfigResponses, UpsertSpaceSettingData, UpsertSpaceSettingResponses, ValidateBucketMountData, ValidateBucketMountErrors, ValidateBucketMountResponses, ValidateGuidelineAssetData, ValidateGuidelineAssetResponses, ValidateMagicLinkData, ValidateMagicLinkErrors, ValidateMagicLinkResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Health check endpoint
 */
export const healthCheck = <ThrowOnError extends boolean = false>(options?: Options<HealthCheckData, ThrowOnError>) => {
    return (options?.client ?? client).get<HealthCheckResponses, HealthCheckErrors, ThrowOnError>({
        url: '/v1/service-status',
        ...options
    });
};

/**
 * List and search AI assets
 *
 * Returns a list of assets. Soft-deleted assets are excluded. Space-scoped assets are returned ahead of global ones sharing a name.
 */
export const listAiAssets = <ThrowOnError extends boolean = false>(options: Options<ListAiAssetsData, ThrowOnError>) => {
    return (options.client ?? client).get<ListAiAssetsResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/aiAssets',
        ...options
    });
};

/**
 * Register a new AI asset in a space
 *
 * Registers a new asset scoped to a specific space. Enforces URI validation and type checks.
 */
export const createAiAsset = <ThrowOnError extends boolean = false>(options: Options<CreateAiAssetData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateAiAssetResponses, CreateAiAssetErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/aiAssets',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get a specific AI asset
 *
 * Retrieves a specific asset by ID. Soft-deleted assets return 404.
 */
export const getAiAssetById = <ThrowOnError extends boolean = false>(options: Options<GetAiAssetByIdData, ThrowOnError>) => {
    return (options.client ?? client).get<GetAiAssetByIdResponses, GetAiAssetByIdErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/aiAssets/{aiAssetID}',
        ...options
    });
};

/**
 * Update an AI asset (Description only)
 *
 * Updates the description of an existing asset. Attempts to modify other fields will be rejected.
 */
export const patchAiAsset = <ThrowOnError extends boolean = false>(options: Options<PatchAiAssetData, ThrowOnError>) => {
    return (options.client ?? client).patch<PatchAiAssetResponses, PatchAiAssetErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/aiAssets/{aiAssetID}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List AI nodes
 */
export const listAiNodes = <ThrowOnError extends boolean = false>(options: Options<ListAiNodesData, ThrowOnError>) => {
    return (options.client ?? client).get<ListAiNodesResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/aiNodes',
        ...options
    });
};

/**
 * Create an AI node draft
 */
export const createAiNode = <ThrowOnError extends boolean = false>(options: Options<CreateAiNodeData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateAiNodeResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/aiNodes',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get an AI node
 */
export const getAiNode = <ThrowOnError extends boolean = false>(options: Options<GetAiNodeData, ThrowOnError>) => {
    return (options.client ?? client).get<GetAiNodeResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/aiNodes/{nodeID}',
        ...options
    });
};

/**
 * Update an AI node draft
 */
export const patchAiNode = <ThrowOnError extends boolean = false>(options: Options<PatchAiNodeData, ThrowOnError>) => {
    return (options.client ?? client).patch<PatchAiNodeResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/aiNodes/{nodeID}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Publish an AI node draft
 */
export const publishAiNode = <ThrowOnError extends boolean = false>(options: Options<PublishAiNodeData, ThrowOnError>) => {
    return (options.client ?? client).post<PublishAiNodeResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/aiNodes/{nodeID}/publish',
        ...options
    });
};

/**
 * Create a new AI node draft version
 */
export const createAiNodeVersion = <ThrowOnError extends boolean = false>(options: Options<CreateAiNodeVersionData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateAiNodeVersionResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/aiNodes/{nodeID}/newVersion',
        ...options
    });
};

/**
 * Deprecate an AI node
 */
export const deprecateAiNode = <ThrowOnError extends boolean = false>(options: Options<DeprecateAiNodeData, ThrowOnError>) => {
    return (options.client ?? client).post<DeprecateAiNodeResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/aiNodes/{nodeID}/deprecate',
        ...options
    });
};

/**
 * Attach an asset to an AI node draft
 */
export const attachAiNodeAsset = <ThrowOnError extends boolean = false>(options: Options<AttachAiNodeAssetData, ThrowOnError>) => {
    return (options.client ?? client).post<AttachAiNodeAssetResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/aiNodes/{nodeID}/assets',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Detach an asset from an AI node draft
 */
export const detachAiNodeAsset = <ThrowOnError extends boolean = false>(options: Options<DetachAiNodeAssetData, ThrowOnError>) => {
    return (options.client ?? client).delete<DetachAiNodeAssetResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/aiNodes/{nodeID}/assets/{linkID}',
        ...options
    });
};

/**
 * List AI node tags
 */
export const listAiNodeTags = <ThrowOnError extends boolean = false>(options: Options<ListAiNodeTagsData, ThrowOnError>) => {
    return (options.client ?? client).get<ListAiNodeTagsResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/aiNodes/tags',
        ...options
    });
};

/**
 * Set an AI node tag
 */
export const setAiNodeTag = <ThrowOnError extends boolean = false>(options: Options<SetAiNodeTagData, ThrowOnError>) => {
    return (options.client ?? client).put<SetAiNodeTagResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/aiNodes/tags',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete an AI node tag
 */
export const deleteAiNodeTag = <ThrowOnError extends boolean = false>(options: Options<DeleteAiNodeTagData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteAiNodeTagResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/aiNodes/tags/{tagID}',
        ...options
    });
};

/**
 * Get a scoped Grafana dashboard URL for a project
 *
 * Returns a Grafana dashboard URL pre-signed with a short-lived JWT for the calling user.
 * The JWT embeds company_id, space_id, and project_id so Grafana can filter data
 * at the correct scope (company → space → project hierarchy).
 * Returns 403 if the caller is not a member of the project.
 *
 */
export const getAnalyticsDashboardUrl = <ThrowOnError extends boolean = false>(options: Options<GetAnalyticsDashboardUrlData, ThrowOnError>) => {
    return (options.client ?? client).get<GetAnalyticsDashboardUrlResponses, GetAnalyticsDashboardUrlErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/analytics/dashboardUrl',
        ...options
    });
};

/**
 * List API keys for the authenticated user
 */
export const listApiKeys = <ThrowOnError extends boolean = false>(options?: Options<ListApiKeysData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListApiKeysResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/iam/api-keys',
        ...options
    });
};

/**
 * Create an API key for the authenticated user
 */
export const createApiKey = <ThrowOnError extends boolean = false>(options: Options<CreateApiKeyData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateApiKeyResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/iam/api-keys',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Revoke an API key
 */
export const revokeApiKey = <ThrowOnError extends boolean = false>(options: Options<RevokeApiKeyData, ThrowOnError>) => {
    return (options.client ?? client).delete<RevokeApiKeyResponses, RevokeApiKeyErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/iam/api-keys/{apiKeyID}',
        ...options
    });
};

/**
 * Get a specific API key for the authenticated user
 */
export const getApiKey = <ThrowOnError extends boolean = false>(options: Options<GetApiKeyData, ThrowOnError>) => {
    return (options.client ?? client).get<GetApiKeyResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/iam/api-keys/{apiKeyID}',
        ...options
    });
};

/**
 * Regenerate the API key (revokes old, issues new)
 */
export const regenerateApiKey = <ThrowOnError extends boolean = false>(options: Options<RegenerateApiKeyData, ThrowOnError>) => {
    return (options.client ?? client).post<RegenerateApiKeyResponses, RegenerateApiKeyErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/iam/api-keys/{apiKeyID}/regenerate',
        ...options
    });
};

/**
 * List asset metadata keys for a space
 */
export const listAssetMetadataKeys = <ThrowOnError extends boolean = false>(options: Options<ListAssetMetadataKeysData, ThrowOnError>) => {
    return (options.client ?? client).get<ListAssetMetadataKeysResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            },
            {
                name: 'X-API-Key',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/assetMetadataKeys',
        ...options
    });
};

/**
 * Create an asset metadata key
 */
export const createAssetMetadataKey = <ThrowOnError extends boolean = false>(options: Options<CreateAssetMetadataKeyData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateAssetMetadataKeyResponses, CreateAssetMetadataKeyErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/assetMetadataKeys',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Archive an asset metadata key
 */
export const archiveAssetMetadataKey = <ThrowOnError extends boolean = false>(options: Options<ArchiveAssetMetadataKeyData, ThrowOnError>) => {
    return (options.client ?? client).delete<ArchiveAssetMetadataKeyResponses, ArchiveAssetMetadataKeyErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/assetMetadataKeys/{metadataKeyID}',
        ...options
    });
};

/**
 * Get all metadata values for an asset
 */
export const getAssetMetadataValues = <ThrowOnError extends boolean = false>(options: Options<GetAssetMetadataValuesData, ThrowOnError>) => {
    return (options.client ?? client).get<GetAssetMetadataValuesResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            },
            {
                name: 'X-API-Key',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/asset/{assetID}/metadata',
        ...options
    });
};

/**
 * Delete an asset by ID
 */
export const deleteAsset = <ThrowOnError extends boolean = false>(options: Options<DeleteAssetData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteAssetResponses, DeleteAssetErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/asset/{assetID}',
        ...options
    });
};

/**
 * Get an asset by ID
 */
export const getAssetById = <ThrowOnError extends boolean = false>(options: Options<GetAssetByIdData, ThrowOnError>) => {
    return (options.client ?? client).get<GetAssetByIdResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/asset/{assetID}',
        ...options
    });
};

/**
 * Move an asset to a different dataset
 */
export const moveAsset = <ThrowOnError extends boolean = false>(options: Options<MoveAssetData, ThrowOnError>) => {
    return (options.client ?? client).patch<MoveAssetResponses, MoveAssetErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/asset/{assetID}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Restore a soft-deleted asset
 */
export const restoreAsset = <ThrowOnError extends boolean = false>(options: Options<RestoreAssetData, ThrowOnError>) => {
    return (options.client ?? client).post<RestoreAssetResponses, RestoreAssetErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/asset/{assetID}/restore',
        ...options
    });
};

/**
 * Permanently delete a soft-deleted asset
 */
export const purgeAsset = <ThrowOnError extends boolean = false>(options: Options<PurgeAssetData, ThrowOnError>) => {
    return (options.client ?? client).post<PurgeAssetResponses, PurgeAssetErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/asset/{assetID}/purge',
        ...options
    });
};

/**
 * Count assets in a space
 */
export const countAssets = <ThrowOnError extends boolean = false>(options: Options<CountAssetsData, ThrowOnError>) => {
    return (options.client ?? client).get<CountAssetsResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/asset/count',
        ...options
    });
};

/**
 * List assets in a space
 */
export const listAssets = <ThrowOnError extends boolean = false>(options: Options<ListAssetsData, ThrowOnError>) => {
    return (options.client ?? client).get<ListAssetsResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/asset',
        ...options
    });
};

/**
 * Upload an asset to a space
 */
export const createAsset = <ThrowOnError extends boolean = false>(options: Options<CreateAssetData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateAssetResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/asset',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get signed urls for upload
 */
export const getUploadUrls = <ThrowOnError extends boolean = false>(options: Options<GetUploadUrlsData, ThrowOnError>) => {
    return (options.client ?? client).get<GetUploadUrlsResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/uploadurls',
        ...options
    });
};

/**
 * Get signed urls for download
 */
export const getSignedUrls = <ThrowOnError extends boolean = false>(options: Options<GetSignedUrlsData, ThrowOnError>) => {
    return (options.client ?? client).post<GetSignedUrlsResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/signedurls',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List asset import jobs for a space
 */
export const listAssetImports = <ThrowOnError extends boolean = false>(options: Options<ListAssetImportsData, ThrowOnError>) => {
    return (options.client ?? client).get<ListAssetImportsResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/assets/imports',
        ...options
    });
};

/**
 * Start a bulk CSV/XLSX or span labelling JSON asset import
 */
export const startAssetImport = <ThrowOnError extends boolean = false>(options: Options<StartAssetImportData, ThrowOnError>) => {
    return (options.client ?? client).post<StartAssetImportResponses, unknown, ThrowOnError>({
        ...formDataBodySerializer,
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/assets/imports',
        ...options,
        headers: {
            'Content-Type': null,
            ...options.headers
        }
    });
};

/**
 * Delete an asset import job
 */
export const deleteAssetImport = <ThrowOnError extends boolean = false>(options: Options<DeleteAssetImportData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteAssetImportResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/assets/imports/{importJobID}',
        ...options
    });
};

/**
 * Get the status and result of an asset import job
 */
export const getAssetImport = <ThrowOnError extends boolean = false>(options: Options<GetAssetImportData, ThrowOnError>) => {
    return (options.client ?? client).get<GetAssetImportResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/assets/imports/{importJobID}',
        ...options
    });
};

/**
 * Trigger VPG job for an asset
 */
export const triggerAssetVpg = <ThrowOnError extends boolean = false>(options: Options<TriggerAssetVpgData, ThrowOnError>) => {
    return (options.client ?? client).post<TriggerAssetVpgResponses, TriggerAssetVpgErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            },
            {
                name: 'X-API-Key',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/asset/{assetID}/vpg',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List all attributes in a space (metadata + current version)
 */
export const listAttributes = <ThrowOnError extends boolean = false>(options: Options<ListAttributesData, ThrowOnError>) => {
    return (options.client ?? client).get<ListAttributesResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/attributes',
        ...options
    });
};

/**
 * Create attributes and promote their initial versions
 *
 * Creates version 1 for each attribute and sets it as the current version. The operation is atomic; if any item fails, no attributes are created.
 */
export const createAttributes = <ThrowOnError extends boolean = false>(options: Options<CreateAttributesData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateAttributesResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/attributes',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get attribute (including current version)
 */
export const getAttribute = <ThrowOnError extends boolean = false>(options: Options<GetAttributeData, ThrowOnError>) => {
    return (options.client ?? client).get<GetAttributeResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/attributes/{attributeID}',
        ...options
    });
};

/**
 * Update attribute (metadata only)
 */
export const updateAttribute = <ThrowOnError extends boolean = false>(options: Options<UpdateAttributeData, ThrowOnError>) => {
    return (options.client ?? client).put<UpdateAttributeResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/attributes/{attributeID}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List all versions of an attribute (metadata only)
 */
export const listAttributeVersions = <ThrowOnError extends boolean = false>(options: Options<ListAttributeVersionsData, ThrowOnError>) => {
    return (options.client ?? client).get<ListAttributeVersionsResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/attributes/{attributeID}/versions',
        ...options
    });
};

/**
 * Create a new version of an existing attribute
 */
export const createAttributeVersion = <ThrowOnError extends boolean = false>(options: Options<CreateAttributeVersionData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateAttributeVersionResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/attributes/{attributeID}/versions',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get a specific version of an attribute
 */
export const getAttributeVersion = <ThrowOnError extends boolean = false>(options: Options<GetAttributeVersionData, ThrowOnError>) => {
    return (options.client ?? client).get<GetAttributeVersionResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/attributes/{attributeID}/versions/{attributeVersionID}',
        ...options
    });
};

/**
 * Promote this attribute version to be the current active version
 */
export const setAttributeVersionCurrent = <ThrowOnError extends boolean = false>(options: Options<SetAttributeVersionCurrentData, ThrowOnError>) => {
    return (options.client ?? client).post<SetAttributeVersionCurrentResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/attributes/{attributeID}/versions/{attributeVersionID}/setCurrent',
        ...options
    });
};

/**
 * List batches in a project with summary stats
 */
export const listBatches = <ThrowOnError extends boolean = false>(options: Options<ListBatchesData, ThrowOnError>) => {
    return (options.client ?? client).get<ListBatchesResponses, ListBatchesErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            },
            {
                name: 'X-API-Key',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/batches',
        ...options
    });
};

/**
 * Create a new batch in a project
 */
export const createBatch = <ThrowOnError extends boolean = false>(options: Options<CreateBatchData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateBatchResponses, CreateBatchErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/batches',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get total number of batches in a project
 */
export const getBatchCount = <ThrowOnError extends boolean = false>(options: Options<GetBatchCountData, ThrowOnError>) => {
    return (options.client ?? client).get<GetBatchCountResponses, GetBatchCountErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/batches/count',
        ...options
    });
};

/**
 * Get batch prioritization configuration for a project
 */
export const getBatchPrioritization = <ThrowOnError extends boolean = false>(options: Options<GetBatchPrioritizationData, ThrowOnError>) => {
    return (options.client ?? client).get<GetBatchPrioritizationResponses, GetBatchPrioritizationErrors, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/batches/prioritization',
        ...options
    });
};

/**
 * Upsert batch prioritization configuration for a project
 */
export const upsertBatchPrioritization = <ThrowOnError extends boolean = false>(options: Options<UpsertBatchPrioritizationData, ThrowOnError>) => {
    return (options.client ?? client).put<UpsertBatchPrioritizationResponses, UpsertBatchPrioritizationErrors, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/batches/prioritization',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Upsert activation state for batches in a project
 */
export const upsertBatchActivation = <ThrowOnError extends boolean = false>(options: Options<UpsertBatchActivationData, ThrowOnError>) => {
    return (options.client ?? client).put<UpsertBatchActivationResponses, UpsertBatchActivationErrors, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/batches/activation',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get a batch by ID
 */
export const getBatchById = <ThrowOnError extends boolean = false>(options: Options<GetBatchByIdData, ThrowOnError>) => {
    return (options.client ?? client).get<GetBatchByIdResponses, GetBatchByIdErrors, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/batches/{batchID}',
        ...options
    });
};

/**
 * Create work items (files) in this batch for provided asset IDs
 *
 * Creates work items for the given asset IDs in the specified batch. When project setting `dedupBatchAssetsByAssetId` is enabled, assets that already have an active work item in this batch (status other than CANCELED or DELETED) are silently skipped. The response includes the IDs of newly created work items in `workItemIds` and the asset IDs that were skipped due to existing active work items in `skippedAssetIds`.
 *
 */
export const addBatchFiles = <ThrowOnError extends boolean = false>(options: Options<AddBatchFilesData, ThrowOnError>) => {
    return (options.client ?? client).post<AddBatchFilesResponses, AddBatchFilesErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/batches/{batchID}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Update a batch
 */
export const updateBatch = <ThrowOnError extends boolean = false>(options: Options<UpdateBatchData, ThrowOnError>) => {
    return (options.client ?? client).put<UpdateBatchResponses, UpdateBatchErrors, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/batches/{batchID}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get bucket mount configuration for a space
 */
export const getBucketMount = <ThrowOnError extends boolean = false>(options: Options<GetBucketMountData, ThrowOnError>) => {
    return (options.client ?? client).get<GetBucketMountResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/bucketMount',
        ...options
    });
};

/**
 * Validate and activate bucket mount configuration for a space
 *
 * Allows users to rotate bucket mount credentials.
 * Users are responsible for ensuring updated credentials still point to the intended mount configuration.
 *
 */
export const upsertBucketMount = <ThrowOnError extends boolean = false>(options: Options<UpsertBucketMountData, ThrowOnError>) => {
    return (options.client ?? client).put<UpsertBucketMountResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/bucketMount',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Validate bucket mount configuration without persisting it
 */
export const validateBucketMount = <ThrowOnError extends boolean = false>(options: Options<ValidateBucketMountData, ThrowOnError>) => {
    return (options.client ?? client).post<ValidateBucketMountResponses, ValidateBucketMountErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/bucketMount/validate',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List bucket mount discovery workflows for a space
 *
 * Returns only the latest 50 discovery workflows, sorted by `createdAt` descending.
 * Items older than the most recent 50 are not returned by this endpoint.
 * The `cursor` query parameter is currently ignored for this endpoint and `meta.cursorNext` is always empty.
 *
 */
export const listBucketMountDiscoveries = <ThrowOnError extends boolean = false>(options: Options<ListBucketMountDiscoveriesData, ThrowOnError>) => {
    return (options.client ?? client).get<ListBucketMountDiscoveriesResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/bucketMount/discoveries',
        ...options
    });
};

/**
 * Trigger bucket mount discovery for a space
 */
export const createBucketMountDiscovery = <ThrowOnError extends boolean = false>(options: Options<CreateBucketMountDiscoveryData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateBucketMountDiscoveryResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/bucketMount/discoveries',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get bucket mount discovery workflow details
 */
export const getBucketMountDiscovery = <ThrowOnError extends boolean = false>(options: Options<GetBucketMountDiscoveryData, ThrowOnError>) => {
    return (options.client ?? client).get<GetBucketMountDiscoveryResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/bucketMount/discoveries/{workflowName}',
        ...options
    });
};

/**
 * List object-level bucket mount discovery results
 */
export const listBucketMountDiscoveryObjects = <ThrowOnError extends boolean = false>(options: Options<ListBucketMountDiscoveryObjectsData, ThrowOnError>) => {
    return (options.client ?? client).get<ListBucketMountDiscoveryObjectsResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/bucketMount/discoveries/{workflowName}/objects',
        ...options
    });
};

/**
 * List companies
 */
export const listCompanies = <ThrowOnError extends boolean = false>(options?: Options<ListCompaniesData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListCompaniesResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/companies',
        ...options
    });
};

/**
 * Create a new company
 */
export const createCompany = <ThrowOnError extends boolean = false>(options: Options<CreateCompanyData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateCompanyResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/companies',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Soft deletes a company
 */
export const deleteCompany = <ThrowOnError extends boolean = false>(options: Options<DeleteCompanyData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteCompanyResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/companies/{companyID}',
        ...options
    });
};

/**
 * Get a company by ID
 */
export const getCompanyById = <ThrowOnError extends boolean = false>(options: Options<GetCompanyByIdData, ThrowOnError>) => {
    return (options.client ?? client).get<GetCompanyByIdResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/companies/{companyID}',
        ...options
    });
};

/**
 * Update a company
 */
export const updateCompany = <ThrowOnError extends boolean = false>(options: Options<UpdateCompanyData, ThrowOnError>) => {
    return (options.client ?? client).put<UpdateCompanyResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/companies/{companyID}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List datasets in a space
 */
export const listDatasets = <ThrowOnError extends boolean = false>(options: Options<ListDatasetsData, ThrowOnError>) => {
    return (options.client ?? client).get<ListDatasetsResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/datasets',
        ...options
    });
};

/**
 * Create a new dataset in a space
 */
export const createDataset = <ThrowOnError extends boolean = false>(options: Options<CreateDatasetData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateDatasetResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/datasets',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete a dataset from a space
 */
export const deleteDataset = <ThrowOnError extends boolean = false>(options: Options<DeleteDatasetData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteDatasetResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/datasets/{datasetID}',
        ...options
    });
};

/**
 * Count datasets in a space
 */
export const countDatasets = <ThrowOnError extends boolean = false>(options: Options<CountDatasetsData, ThrowOnError>) => {
    return (options.client ?? client).get<CountDatasetsResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/dataset/count',
        ...options
    });
};

/**
 * List Evaluation Profiles for a project (excludes archived)
 */
export const listEvaluationProfiles = <ThrowOnError extends boolean = false>(options: Options<ListEvaluationProfilesData, ThrowOnError>) => {
    return (options.client ?? client).get<ListEvaluationProfilesResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/evaluationProfiles',
        ...options
    });
};

/**
 * Create a new Evaluation Profile (creates version 1 and makes it current)
 */
export const createEvaluationProfile = <ThrowOnError extends boolean = false>(options: Options<CreateEvaluationProfileData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateEvaluationProfileResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/evaluationProfiles',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Archive an Evaluation Profile (soft delete; versions and results are preserved)
 */
export const archiveEvaluationProfile = <ThrowOnError extends boolean = false>(options: Options<ArchiveEvaluationProfileData, ThrowOnError>) => {
    return (options.client ?? client).delete<ArchiveEvaluationProfileResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/evaluationProfiles/{evaluationProfileID}',
        ...options
    });
};

/**
 * Get an Evaluation Profile (including its current version)
 */
export const getEvaluationProfile = <ThrowOnError extends boolean = false>(options: Options<GetEvaluationProfileData, ThrowOnError>) => {
    return (options.client ?? client).get<GetEvaluationProfileResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/evaluationProfiles/{evaluationProfileID}',
        ...options
    });
};

/**
 * Update Evaluation Profile metadata (name and description)
 */
export const updateEvaluationProfile = <ThrowOnError extends boolean = false>(options: Options<UpdateEvaluationProfileData, ThrowOnError>) => {
    return (options.client ?? client).put<UpdateEvaluationProfileResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/evaluationProfiles/{evaluationProfileID}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List all Evaluation Profile Versions for a profile
 */
export const listEvaluationProfileVersions = <ThrowOnError extends boolean = false>(options: Options<ListEvaluationProfileVersionsData, ThrowOnError>) => {
    return (options.client ?? client).get<ListEvaluationProfileVersionsResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/evaluationProfiles/{evaluationProfileID}/versions',
        ...options
    });
};

/**
 * Create the next immutable Evaluation Profile Version and make it current
 */
export const createEvaluationProfileVersion = <ThrowOnError extends boolean = false>(options: Options<CreateEvaluationProfileVersionData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateEvaluationProfileVersionResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/evaluationProfiles/{evaluationProfileID}/versions',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get a specific Evaluation Profile Version
 */
export const getEvaluationProfileVersion = <ThrowOnError extends boolean = false>(options: Options<GetEvaluationProfileVersionData, ThrowOnError>) => {
    return (options.client ?? client).get<GetEvaluationProfileVersionResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/evaluationProfiles/{evaluationProfileID}/versions/{evaluationProfileVersionID}',
        ...options
    });
};

/**
 * List exports for a space
 *
 * Returns all exports for the given space, ordered by creation date (most recent first).
 */
export const internalListExports = <ThrowOnError extends boolean = false>(options: Options<InternalListExportsData, ThrowOnError>) => {
    return (options.client ?? client).get<InternalListExportsResponses, InternalListExportsErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/exports',
        ...options
    });
};

/**
 * Create an export
 *
 * Starts an async export as a zip file. Supports COCO_JSON (annotation data, the default), or CSV/JSON with a selectable content: ANNOTATION (default) for annotation output, or ASSET_METADATA for each work item's related asset ID and structured metadata. Only one active export per space is allowed; returns 409 if an export is already running.
 */
export const internalCreateExport = <ThrowOnError extends boolean = false>(options: Options<InternalCreateExportData, ThrowOnError>) => {
    return (options.client ?? client).post<InternalCreateExportResponses, InternalCreateExportErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/exports',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete an export
 *
 * Deletes an export and its associated zip file from storage. Can be called for exports in any status.
 */
export const internalDeleteExport = <ThrowOnError extends boolean = false>(options: Options<InternalDeleteExportData, ThrowOnError>) => {
    return (options.client ?? client).delete<InternalDeleteExportResponses, InternalDeleteExportErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/exports/{exportID}',
        ...options
    });
};

/**
 * Get export status
 *
 * Returns the current status of an export. When COMPLETED, includes a pre-signed download URL valid for 7 days.
 */
export const internalGetExport = <ThrowOnError extends boolean = false>(options: Options<InternalGetExportData, ThrowOnError>) => {
    return (options.client ?? client).get<InternalGetExportResponses, InternalGetExportErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/exports/{exportID}',
        ...options
    });
};

/**
 * List all forms (metadata only)
 */
export const listForms = <ThrowOnError extends boolean = false>(options: Options<ListFormsData, ThrowOnError>) => {
    return (options.client ?? client).get<ListFormsResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/forms',
        ...options
    });
};

/**
 * Create a new form (creates version 1)
 */
export const createForm = <ThrowOnError extends boolean = false>(options: Options<CreateFormData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateFormResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/forms',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete a form (including all its versions)
 */
export const deleteForm = <ThrowOnError extends boolean = false>(options: Options<DeleteFormData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteFormResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/forms/{formID}',
        ...options
    });
};

/**
 * Get form (including current version)
 */
export const getForm = <ThrowOnError extends boolean = false>(options: Options<GetFormData, ThrowOnError>) => {
    return (options.client ?? client).get<GetFormResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/forms/{formID}',
        ...options
    });
};

/**
 * Update form (metadata only)
 */
export const updateForm = <ThrowOnError extends boolean = false>(options: Options<UpdateFormData, ThrowOnError>) => {
    return (options.client ?? client).put<UpdateFormResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/forms/{formID}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List all form versions (metadata only)
 */
export const listFormVersions = <ThrowOnError extends boolean = false>(options: Options<ListFormVersionsData, ThrowOnError>) => {
    return (options.client ?? client).get<ListFormVersionsResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/forms/{formID}/versions',
        ...options
    });
};

/**
 * Create a new version of an existing form
 */
export const createFormVersion = <ThrowOnError extends boolean = false>(options: Options<CreateFormVersionData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateFormVersionResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/forms/{formID}/versions',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get a specific version of a form
 */
export const getFormVersion = <ThrowOnError extends boolean = false>(options: Options<GetFormVersionData, ThrowOnError>) => {
    return (options.client ?? client).get<GetFormVersionResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/forms/{formID}/versions/{formVersionID}',
        ...options
    });
};

/**
 * Update form version (metadata only)
 */
export const updateFormVersion = <ThrowOnError extends boolean = false>(options: Options<UpdateFormVersionData, ThrowOnError>) => {
    return (options.client ?? client).put<UpdateFormVersionResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/forms/{formID}/versions/{formVersionID}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Set this form version as the current version
 */
export const setFormVersionCurrent = <ThrowOnError extends boolean = false>(options: Options<SetFormVersionCurrentData, ThrowOnError>) => {
    return (options.client ?? client).post<SetFormVersionCurrentResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/forms/{formID}/versions/{formVersionID}/set-current',
        ...options
    });
};

/**
 * List all guidelines
 */
export const listGuidelines = <ThrowOnError extends boolean = false>(options: Options<ListGuidelinesData, ThrowOnError>) => {
    return (options.client ?? client).get<ListGuidelinesResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/guidelines',
        ...options
    });
};

/**
 * Create a new Guidelien (creates version 1)
 */
export const createGuideline = <ThrowOnError extends boolean = false>(options: Options<CreateGuidelineData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateGuidelineResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            }
        ],
        url: '/v2/spaces/{spaceID}/guidelines',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete a Guideline (including all its versions and asset mappings)
 */
export const deleteGuideline = <ThrowOnError extends boolean = false>(options: Options<DeleteGuidelineData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteGuidelineResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/guidelines/{guidelineID}',
        ...options
    });
};

/**
 * Get Guideline
 */
export const getGuideline = <ThrowOnError extends boolean = false>(options: Options<GetGuidelineData, ThrowOnError>) => {
    return (options.client ?? client).get<GetGuidelineResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/guidelines/{guidelineID}',
        ...options
    });
};

/**
 * Update guideline metadata
 */
export const updateGuideline = <ThrowOnError extends boolean = false>(options: Options<UpdateGuidelineData, ThrowOnError>) => {
    return (options.client ?? client).put<UpdateGuidelineResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/guidelines/{guidelineID}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List all guideline versions metadata
 */
export const listGuidelineVersions = <ThrowOnError extends boolean = false>(options: Options<ListGuidelineVersionsData, ThrowOnError>) => {
    return (options.client ?? client).get<ListGuidelineVersionsResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/guidelines/{guidelineID}/versions',
        ...options
    });
};

/**
 * Create a new Guideline Version for existing Guideline
 */
export const createGuidelineVersion = <ThrowOnError extends boolean = false>(options: Options<CreateGuidelineVersionData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateGuidelineVersionResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/guidelines/{guidelineID}/versions',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get a specific guideline version
 */
export const getGuidelineVersion = <ThrowOnError extends boolean = false>(options: Options<GetGuidelineVersionData, ThrowOnError>) => {
    return (options.client ?? client).get<GetGuidelineVersionResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/guidelines/{guidelineID}/versions/{guidelineVersionID}',
        ...options
    });
};

/**
 * Update Guideline version metadata only
 */
export const updateGuidelineVersion = <ThrowOnError extends boolean = false>(options: Options<UpdateGuidelineVersionData, ThrowOnError>) => {
    return (options.client ?? client).put<UpdateGuidelineVersionResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/guidelines/{guidelineID}/versions/{guidelineVersionID}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Set this guideline version as the active version
 */
export const setGuidelineVersionCurrent = <ThrowOnError extends boolean = false>(options: Options<SetGuidelineVersionCurrentData, ThrowOnError>) => {
    return (options.client ?? client).post<SetGuidelineVersionCurrentResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/guidelines/{guidelineID}/versions/{guidelineVersionID}/set-current',
        ...options
    });
};

/**
 * Get signed urls for upload in Guidelines.
 */
export const getGuidelineUploadUrls = <ThrowOnError extends boolean = false>(options: Options<GetGuidelineUploadUrlsData, ThrowOnError>) => {
    return (options.client ?? client).get<GetGuidelineUploadUrlsResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/guidelines/uploadurls',
        ...options
    });
};

/**
 * Upload Guideline asset.
 */
export const createGuidelineAsset = <ThrowOnError extends boolean = false>(options: Options<CreateGuidelineAssetData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateGuidelineAssetResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/guidelines/{guidelineID}/assets',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Guideline assets documents.
 */
export const listGuidelineAssetDocuments = <ThrowOnError extends boolean = false>(options: Options<ListGuidelineAssetDocumentsData, ThrowOnError>) => {
    return (options.client ?? client).get<ListGuidelineAssetDocumentsResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/guidelines/{guidelineID}/assets/documents',
        ...options
    });
};

/**
 * Validate Guideline asset.
 */
export const validateGuidelineAsset = <ThrowOnError extends boolean = false>(options: Options<ValidateGuidelineAssetData, ThrowOnError>) => {
    return (options.client ?? client).post<ValidateGuidelineAssetResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/guidelines/assets/validate',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Launch guideline generation job
 */
export const launchGuidelineGeneration = <ThrowOnError extends boolean = false>(options: Options<LaunchGuidelineGenerationData, ThrowOnError>) => {
    return (options.client ?? client).post<LaunchGuidelineGenerationResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/guidelines/generate',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Login or validate session
 */
export const loginUser = <ThrowOnError extends boolean = false>(options?: Options<LoginUserData, ThrowOnError>) => {
    return (options?.client ?? client).post<LoginUserResponses, unknown, ThrowOnError>({
        url: '/v1/auth/login',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Log out the user
 */
export const logoutUser = <ThrowOnError extends boolean = false>(options?: Options<LogoutUserData, ThrowOnError>) => {
    return (options?.client ?? client).post<LogoutUserResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/auth/logout',
        ...options
    });
};

/**
 * JWT token login
 */
export const jwtUserLogin = <ThrowOnError extends boolean = false>(options?: Options<JwtUserLoginData, ThrowOnError>) => {
    return (options?.client ?? client).post<JwtUserLoginResponses, unknown, ThrowOnError>({
        url: '/v1/auth/token',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Request a magic link for passwordless login
 *
 * Sends a magic link to the provided email address if the user exists and has active membership.
 * Always returns success to prevent email enumeration attacks.
 *
 */
export const requestMagicLink = <ThrowOnError extends boolean = false>(options: Options<RequestMagicLinkData, ThrowOnError>) => {
    return (options.client ?? client).post<RequestMagicLinkResponses, unknown, ThrowOnError>({
        url: '/v1/auth/magicLink/request',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Validate magic link token and create session
 *
 * Validates the magic link JWT token and creates an authenticated session.
 * Returns user info, redirect URL, and sets session cookie on success.
 *
 */
export const validateMagicLink = <ThrowOnError extends boolean = false>(options: Options<ValidateMagicLinkData, ThrowOnError>) => {
    return (options.client ?? client).post<ValidateMagicLinkResponses, ValidateMagicLinkErrors, ThrowOnError>({
        url: '/v1/auth/magicLink/validate',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get invite redirect URL
 *
 * Validates the invite and returns the redirect path for the frontend.
 * Returns a relative path (e.g., /spaces/xxx/projects/yyy/dashboard).
 * Frontend should use this with router navigation (e.g., router.push(url)).
 *
 */
export const redirectInvite = <ThrowOnError extends boolean = false>(options: Options<RedirectInviteData, ThrowOnError>) => {
    return (options.client ?? client).get<RedirectInviteResponses, RedirectInviteErrors, ThrowOnError>({
        url: '/v1/invite',
        ...options
    });
};

/**
 * Import a guideline from uploaded PDFs or external source (store without AI generation).
 *
 * Creates a new guideline (or adds a new version if the name already exists)
 * from previously uploaded PDF files (UI) or from an external source (Task Builder/external).
 * The PDFs are stored as-is without triggering AI content generation. The guideline version is immediately published.
 *
 * - For UI: provide `documents` and set `source` to "upload".
 * - For Task Builder/external: provide `document_key` (and optionally `external_ref`), set `source` to "external".
 *
 */
export const importGuideline = <ThrowOnError extends boolean = false>(options: Options<ImportGuidelineData, ThrowOnError>) => {
    return (options.client ?? client).post<ImportGuidelineResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            },
            {
                name: 'X-API-Key',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/guidelines/import',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List jobs filtered by labels
 */
export const listJobs = <ThrowOnError extends boolean = false>(options?: Options<ListJobsData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListJobsResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/jobs',
        ...options
    });
};

/**
 * Trigger an Argo workflow job
 */
export const createJob = <ThrowOnError extends boolean = false>(options: Options<CreateJobData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateJobResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/jobs',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List all label classes in a space (metadata + current version)
 */
export const listLabelClasses = <ThrowOnError extends boolean = false>(options: Options<ListLabelClassesData, ThrowOnError>) => {
    return (options.client ?? client).get<ListLabelClassesResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/labelClasses',
        ...options
    });
};

/**
 * Create label classes and promote their initial versions
 *
 * Creates version 1 for each label class and sets it as the current version. The operation is atomic; if any item fails, no label classes are created.
 */
export const createLabelClasses = <ThrowOnError extends boolean = false>(options: Options<CreateLabelClassesData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateLabelClassesResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/labelClasses',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get label class (including current version)
 */
export const getLabelClass = <ThrowOnError extends boolean = false>(options: Options<GetLabelClassData, ThrowOnError>) => {
    return (options.client ?? client).get<GetLabelClassResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/labelClasses/{labelClassID}',
        ...options
    });
};

/**
 * Update label class (metadata only)
 */
export const updateLabelClass = <ThrowOnError extends boolean = false>(options: Options<UpdateLabelClassData, ThrowOnError>) => {
    return (options.client ?? client).put<UpdateLabelClassResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/labelClasses/{labelClassID}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List all versions of a label class (metadata only)
 */
export const listLabelClassVersions = <ThrowOnError extends boolean = false>(options: Options<ListLabelClassVersionsData, ThrowOnError>) => {
    return (options.client ?? client).get<ListLabelClassVersionsResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/labelClasses/{labelClassID}/versions',
        ...options
    });
};

/**
 * Create a new version of an existing label class
 */
export const createLabelClassVersion = <ThrowOnError extends boolean = false>(options: Options<CreateLabelClassVersionData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateLabelClassVersionResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/labelClasses/{labelClassID}/versions',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get a specific version of a label class
 */
export const getLabelClassVersion = <ThrowOnError extends boolean = false>(options: Options<GetLabelClassVersionData, ThrowOnError>) => {
    return (options.client ?? client).get<GetLabelClassVersionResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/labelClasses/{labelClassID}/versions/{labelClassVersionID}',
        ...options
    });
};

/**
 * Promote this label class version to be the current active version
 */
export const setLabelClassVersionCurrent = <ThrowOnError extends boolean = false>(options: Options<SetLabelClassVersionCurrentData, ThrowOnError>) => {
    return (options.client ?? client).post<SetLabelClassVersionCurrentResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/labelClasses/{labelClassID}/versions/{labelClassVersionID}/setCurrent',
        ...options
    });
};

/**
 * Get the project's class layout (activation, order, geometry restrictions)
 */
export const getClassLayout = <ThrowOnError extends boolean = false>(options: Options<GetClassLayoutData, ThrowOnError>) => {
    return (options.client ?? client).get<GetClassLayoutResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/projects/{projectID}/classLayouts',
        ...options
    });
};

/**
 * Upsert the project's class layout (bulk-replace; writes an audit snapshot)
 */
export const upsertClassLayout = <ThrowOnError extends boolean = false>(options: Options<UpsertClassLayoutData, ThrowOnError>) => {
    return (options.client ?? client).put<UpsertClassLayoutResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/projects/{projectID}/classLayouts',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get the active label classes available to the annotation tool
 *
 * Returns only active project class-layout entries, ordered by display order. Each entry resolves the label class's current version, and `referencedSchemas` contains every Attribute Version schema referenced by those versions, so the annotation tool can render attribute forms without additional requests.
 */
export const getAnnotationConfig = <ThrowOnError extends boolean = false>(options: Options<GetAnnotationConfigData, ThrowOnError>) => {
    return (options.client ?? client).get<GetAnnotationConfigResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/projects/{projectID}/annotationConfig',
        ...options
    });
};

/**
 * Remove a member from an entity
 */
export const removeMembers = <ThrowOnError extends boolean = false>(options: Options<RemoveMembersData, ThrowOnError>) => {
    return (options.client ?? client).delete<RemoveMembersResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/members',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List all members in a entity
 *
 * Returns the members of an entity. Pagination is opt-in: when none of `limit`, `cursor` or `page` is supplied every matching member is returned and `meta` is omitted.
 */
export const listMembers = <ThrowOnError extends boolean = false>(options: Options<ListMembersData, ThrowOnError>) => {
    return (options.client ?? client).get<ListMembersResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/members',
        ...options
    });
};

/**
 * Add a member to an entity
 */
export const addMembers = <ThrowOnError extends boolean = false>(options: Options<AddMembersData, ThrowOnError>) => {
    return (options.client ?? client).post<AddMembersResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/members',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Count the members of an entity
 *
 * Returns the number of members of an entity matching the given filters. Accepts the same filters as `listMembers` so that the count reflects the currently displayed result set.
 */
export const countMembers = <ThrowOnError extends boolean = false>(options: Options<CountMembersData, ThrowOnError>) => {
    return (options.client ?? client).get<CountMembersResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/members/count',
        ...options
    });
};

/**
 * Get details of a specific member
 */
export const getMember = <ThrowOnError extends boolean = false>(options: Options<GetMemberData, ThrowOnError>) => {
    return (options.client ?? client).get<GetMemberResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            }
        ],
        url: '/v1/members/{memberID}',
        ...options
    });
};

/**
 * Subscribe to the SSE notification stream
 */
export const streamNotifications = <ThrowOnError extends boolean = false>(options?: Options<StreamNotificationsData, ThrowOnError>) => {
    return (options?.client ?? client).sse.get<StreamNotificationsResponses, StreamNotificationsErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/notifications/stream',
        ...options
    });
};

/**
 * List output names for a given space
 */
export const listOutputNames = <ThrowOnError extends boolean = false>(options: Options<ListOutputNamesData, ThrowOnError>) => {
    return (options.client ?? client).get<ListOutputNamesResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/outputNames',
        ...options
    });
};

/**
 * Create output name for a given space
 */
export const createOutputName = <ThrowOnError extends boolean = false>(options: Options<CreateOutputNameData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateOutputNameResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/outputNames',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Archive output name for a given space, and output name ID
 *
 * Archive output name for a given space, and output name ID. The output name will be marked as deleted and will not be returned in future list or get requests.
 */
export const archiveOutputName = <ThrowOnError extends boolean = false>(options: Options<ArchiveOutputNameData, ThrowOnError>) => {
    return (options.client ?? client).delete<ArchiveOutputNameResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/outputNames/{outputNameID}',
        ...options
    });
};

/**
 * Get a specific output name for a given space
 */
export const getOutputName = <ThrowOnError extends boolean = false>(options: Options<GetOutputNameData, ThrowOnError>) => {
    return (options.client ?? client).get<GetOutputNameResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/outputNames/{outputNameID}',
        ...options
    });
};

/**
 * Update output name for a given space, and output name ID
 *
 * Update output name for a given space, and output name ID. Only the fields provided in the request body will be updated. Other fields will remain unchanged.
 */
export const updateOutputName = <ThrowOnError extends boolean = false>(options: Options<UpdateOutputNameData, ThrowOnError>) => {
    return (options.client ?? client).put<UpdateOutputNameResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/outputNames/{outputNameID}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List Role Permissions
 *
 * Returns a map of roles to their associated permissions across all entity types (company, space, project). The permissions are read dynamically from the OpenFGA authorization model.
 */
export const listPermissions = <ThrowOnError extends boolean = false>(options?: Options<ListPermissionsData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListPermissionsResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/permissions',
        ...options
    });
};

/**
 * List platform projects with priority configuration
 *
 * Platform-admin list of all non-deleted projects across organizations,
 * including space/organization names and optional priority-config fields.
 * Default sort is organization name (plus project ID as a tie-breaker).
 * Pass sortBy to order by a different column.
 *
 */
export const listPlatformProjects = <ThrowOnError extends boolean = false>(options?: Options<ListPlatformProjectsData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListPlatformProjectsResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects',
        ...options
    });
};

/**
 * Count platform projects matching filters
 *
 * Platform-admin count of non-deleted projects across organizations.
 * Accepts the same companyIDs, spaceIDs, and name filters as listPlatformProjects.
 *
 */
export const countPlatformProjects = <ThrowOnError extends boolean = false>(options?: Options<CountPlatformProjectsData, ThrowOnError>) => {
    return (options?.client ?? client).get<CountPlatformProjectsResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/count',
        ...options
    });
};

/**
 * List all projects
 */
export const listProjects = <ThrowOnError extends boolean = false>(options: Options<ListProjectsData, ThrowOnError>) => {
    return (options.client ?? client).get<ListProjectsResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            },
            {
                name: 'X-API-Key',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/projects',
        ...options
    });
};

/**
 * Create a new project
 */
export const createProject = <ThrowOnError extends boolean = false>(options: Options<CreateProjectData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateProjectResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/projects',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Soft deletes a project
 */
export const deleteProject = <ThrowOnError extends boolean = false>(options: Options<DeleteProjectData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteProjectResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/projects/{projectID}',
        ...options
    });
};

/**
 * Get Project by ID
 */
export const getProjectById = <ThrowOnError extends boolean = false>(options: Options<GetProjectByIdData, ThrowOnError>) => {
    return (options.client ?? client).get<GetProjectByIdResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/projects/{projectID}',
        ...options
    });
};

/**
 * Update a project
 */
export const updateProject = <ThrowOnError extends boolean = false>(options: Options<UpdateProjectData, ThrowOnError>) => {
    return (options.client ?? client).put<UpdateProjectResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/projects/{projectID}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Switch workflow for a project
 */
export const projectWorkflowSwitch = <ThrowOnError extends boolean = false>(options: Options<ProjectWorkflowSwitchData, ThrowOnError>) => {
    return (options.client ?? client).put<ProjectWorkflowSwitchResponses, ProjectWorkflowSwitchErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/projects/{projectID}/workflow',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get priority config for a project
 */
export const getProjectPriorityConfig = <ThrowOnError extends boolean = false>(options: Options<GetProjectPriorityConfigData, ThrowOnError>) => {
    return (options.client ?? client).get<GetProjectPriorityConfigResponses, GetProjectPriorityConfigErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/priorityConfig',
        ...options
    });
};

/**
 * Upsert priority config for a project
 */
export const upsertProjectPriorityConfig = <ThrowOnError extends boolean = false>(options: Options<UpsertProjectPriorityConfigData, ThrowOnError>) => {
    return (options.client ?? client).put<UpsertProjectPriorityConfigResponses, UpsertProjectPriorityConfigErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/priorityConfig',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get collaborators for a project
 */
export const getProjectCollaborators = <ThrowOnError extends boolean = false>(options: Options<GetProjectCollaboratorsData, ThrowOnError>) => {
    return (options.client ?? client).get<GetProjectCollaboratorsResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/collaborators',
        ...options
    });
};

/**
 * List assignable tasks for the current user
 */
export const listAssignableTasksForUser = <ThrowOnError extends boolean = false>(options?: Options<ListAssignableTasksForUserData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListAssignableTasksForUserResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/tasks/assignable',
        ...options
    });
};

/**
 * Assign a specific task to the current user
 */
export const assignSpecificTaskToUser = <ThrowOnError extends boolean = false>(options: Options<AssignSpecificTaskToUserData, ThrowOnError>) => {
    return (options.client ?? client).post<AssignSpecificTaskToUserResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/tasks/{taskID}/assign',
        ...options
    });
};

/**
 * Update status from filtered tasks
 */
export const statusUpdateTasks = <ThrowOnError extends boolean = false>(options: Options<StatusUpdateTasksData, ThrowOnError>) => {
    return (options.client ?? client).put<StatusUpdateTasksResponses, unknown, ThrowOnError>({
        querySerializer: {
            parameters: {
                statuses: {
                    array: {
                        explode: false
                    }
                }
            }
        },
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/tasks/status',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Accept or reject a pending interruption offer
 *
 * Lets a CloudWorker respond to an interruption offer created by the priority
 * sweeper (design doc: Dynamic Task Routing — Phase 2, §4.6/§4.10). On accept,
 * in one transaction: releases taskID back to NEW with a resume reservation for
 * this worker, and claims the offered candidate task — returning its
 * FormDetails. If the candidate is no longer claimable, the offer is marked
 * expired and no state on the current session changes. On reject, the current
 * session is left untouched and 204 is returned.
 *
 */
export const respondToInterruptionOffer = <ThrowOnError extends boolean = false>(options: Options<RespondToInterruptionOfferData, ThrowOnError>) => {
    return (options.client ?? client).post<RespondToInterruptionOfferResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/tasks/{taskID}/taskSessions/{sessionID}/respond',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get a task by ID
 */
export const getTaskById = <ThrowOnError extends boolean = false>(options: Options<GetTaskByIdData, ThrowOnError>) => {
    return (options.client ?? client).get<GetTaskByIdResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/tasks/{taskID}',
        ...options
    });
};

/**
 * Complete a task
 */
export const completeUserTask = <ThrowOnError extends boolean = false>(options: Options<CompleteUserTaskData, ThrowOnError>) => {
    return (options.client ?? client).put<CompleteUserTaskResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/tasks/{taskID}/complete',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Acknowledge heuristic validation errors for a task
 *
 * Allows a Labeller or Reviewer assigned to a task to acknowledge heuristic-rule
 * errors raised against the work item. Creates a single feedback row with type ACK
 * and status COMPLETED. Feedback may include document-level comments and/or
 * per-field acknowledgements.
 *
 */
export const recordTaskValidationAck = <ThrowOnError extends boolean = false>(options: Options<RecordTaskValidationAckData, ThrowOnError>) => {
    return (options.client ?? client).post<RecordTaskValidationAckResponses, RecordTaskValidationAckErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/tasks/{taskID}/validationAcknowledgements',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get the latest saved in-progress form output for a task
 *
 * Returns the most recently updated live (non-soft-deleted) draft
 * FormOutput stashed for the given task, regardless of which worker
 * saved it. Drafts are task-scoped on read so that when a task changes
 * hands, the incoming worker inherits the outgoing worker's in-flight
 * state and no work is lost across reassignment. Returns 404 when no
 * live draft exists for the task — e.g. one has never been saved, or
 * it has already been consumed on resume.
 *
 */
export const getTaskDraft = <ThrowOnError extends boolean = false>(options: Options<GetTaskDraftData, ThrowOnError>) => {
    return (options.client ?? client).get<GetTaskDraftResponses, GetTaskDraftErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/tasks/{taskID}/draft',
        ...options
    });
};

/**
 * Save a draft of the in-progress form output for a task
 *
 * Stashes the caller's in-flight FormOutput for a task they currently
 * have assigned, without completing it or touching the task's own
 * form_output. At most one live draft is kept per (task, worker) — a
 * repeated save overwrites the previous draft. Draft consumption
 * (loading + soft-delete on resume) happens automatically the next
 * time the caller is re-assigned this task.
 *
 */
export const saveTaskDraft = <ThrowOnError extends boolean = false>(options: Options<SaveTaskDraftData, ThrowOnError>) => {
    return (options.client ?? client).put<SaveTaskDraftResponses, SaveTaskDraftErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/tasks/{taskID}/draft',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Assign task to user
 */
export const assignTaskToUser = <ThrowOnError extends boolean = false>(options?: Options<AssignTaskToUserData, ThrowOnError>) => {
    return (options?.client ?? client).post<AssignTaskToUserResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/tasks/assign',
        ...options
    });
};

/**
 * Count tasks under a project with optional filters
 */
export const countTasks = <ThrowOnError extends boolean = false>(options: Options<CountTasksData, ThrowOnError>) => {
    return (options.client ?? client).get<CountTasksResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/tasks/count',
        ...options
    });
};

/**
 * List tasks
 */
export const listTasks = <ThrowOnError extends boolean = false>(options: Options<ListTasksData, ThrowOnError>) => {
    return (options.client ?? client).get<ListTasksResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/tasks',
        ...options
    });
};

/**
 * Admin/Owner takeover of a task (Manage Mode)
 *
 * Allows an Admin or Owner to atomically unassign any existing assignee and
 * claim a NEW or IN_PROGRESS task for themselves. Returns FormDetails so the
 * task screen can be opened immediately. Restricted to project owners and
 * administrators via project:project_manage.
 *
 */
export const takeoverTask = <ThrowOnError extends boolean = false>(options: Options<TakeoverTaskData, ThrowOnError>) => {
    return (options.client ?? client).post<TakeoverTaskResponses, TakeoverTaskErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/tasks/{taskID}/takeover',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Unassign tasks
 */
export const unassignTasks = <ThrowOnError extends boolean = false>(options: Options<UnassignTasksData, ThrowOnError>) => {
    return (options.client ?? client).put<UnassignTasksResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            },
            {
                name: 'X-API-Key',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/tasks/unassign',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Force complete a stalled task (Admin only)
 *
 * Allows a System Administrator to forcibly transition a stalled task from
 * NEW or IN_PROGRESS to DONE, attributing the completion to a specified
 * Cloudworker. Triggers the same downstream workflow signals as a normal
 * task completion. If the task was already completed by an automated signal,
 * the operation returns success (idempotent/race-condition safe).
 *
 */
export const forceCompleteTask = <ThrowOnError extends boolean = false>(options: Options<ForceCompleteTaskData, ThrowOnError>) => {
    return (options.client ?? client).post<ForceCompleteTaskResponses, ForceCompleteTaskErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/tasks/{taskID}/forceComplete',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Submit a bulk force complete job (Admin only)
 *
 * Enqueues an asynchronous job that force-completes many tasks in one action.
 * Returns a jobId immediately; the caller polls the status endpoint for
 * progress and outcome. See docs/design/2026-08-24-bulk-force-complete.md.
 *
 */
export const submitBulkForceCompleteJob = <ThrowOnError extends boolean = false>(options: Options<SubmitBulkForceCompleteJobData, ThrowOnError>) => {
    return (options.client ?? client).post<SubmitBulkForceCompleteJobResponses, SubmitBulkForceCompleteJobErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/tasks/bulkForceComplete',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get a bulk force complete job status (Admin only)
 */
export const getBulkForceCompleteJob = <ThrowOnError extends boolean = false>(options: Options<GetBulkForceCompleteJobData, ThrowOnError>) => {
    return (options.client ?? client).get<GetBulkForceCompleteJobResponses, GetBulkForceCompleteJobErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/bulkForceCompleteJobs/{jobID}',
        ...options
    });
};

/**
 * Bulk unassign tasks (Admin only)
 *
 * Unassigns many IN_PROGRESS tasks in one action, either by explicit task
 * IDs or by a server-resolved filter. Resolves and validates the scope,
 * then unassigns eligible tasks and returns 202 with a job ID; per-item
 * results are recorded for audit even though unassign settles synchronously.
 *
 */
export const bulkUnassignTasks = <ThrowOnError extends boolean = false>(options: Options<BulkUnassignTasksData, ThrowOnError>) => {
    return (options.client ?? client).post<BulkUnassignTasksResponses, BulkUnassignTasksErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/tasks/bulk/unassign',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get a read-only view of a completed task (form and submitted inference)
 */
export const getTaskView = <ThrowOnError extends boolean = false>(options: Options<GetTaskViewData, ThrowOnError>) => {
    return (options.client ?? client).get<GetTaskViewResponses, GetTaskViewErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/tasks/{taskID}/view',
        ...options
    });
};

/**
 * List User Roles
 */
export const listUserRoles = <ThrowOnError extends boolean = false>(options: Options<ListUserRolesData, ThrowOnError>) => {
    return (options.client ?? client).get<ListUserRolesResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/roles',
        ...options
    });
};

/**
 * Assign Roles to Users
 */
export const assignRolesToUsers = <ThrowOnError extends boolean = false>(options: Options<AssignRolesToUsersData, ThrowOnError>) => {
    return (options.client ?? client).post<AssignRolesToUsersResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/roles',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Update Roles from Users
 */
export const updateRolesFromUsers = <ThrowOnError extends boolean = false>(options: Options<UpdateRolesFromUsersData, ThrowOnError>) => {
    return (options.client ?? client).put<UpdateRolesFromUsersResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/roles',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List Platform Admins
 */
export const listPlatformAdmins = <ThrowOnError extends boolean = false>(options?: Options<ListPlatformAdminsData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListPlatformAdminsResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            }
        ],
        url: '/v1/roles/platform_admin',
        ...options
    });
};

/**
 * Revoke Platform Admin Role from User
 */
export const revokePlatformAdminRole = <ThrowOnError extends boolean = false>(options: Options<RevokePlatformAdminRoleData, ThrowOnError>) => {
    return (options.client ?? client).delete<RevokePlatformAdminRoleResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            }
        ],
        url: '/v1/roles/{userID}/platform_admin',
        ...options
    });
};

/**
 * Assign Platform Admin Role to User
 */
export const assignPlatformAdminRole = <ThrowOnError extends boolean = false>(options: Options<AssignPlatformAdminRoleData, ThrowOnError>) => {
    return (options.client ?? client).post<AssignPlatformAdminRoleResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            }
        ],
        url: '/v1/roles/{userID}/platform_admin',
        ...options
    });
};

/**
 * Process Samplers
 */
export const processConsensusSampler = <ThrowOnError extends boolean = false>(options: Options<ProcessConsensusSamplerData, ThrowOnError>) => {
    return (options.client ?? client).post<ProcessConsensusSamplerResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/workitem/{workItemID}/samplers/consensus',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Process Samplers
 */
export const processRandomSampler = <ThrowOnError extends boolean = false>(options: Options<ProcessRandomSamplerData, ThrowOnError>) => {
    return (options.client ?? client).post<ProcessRandomSamplerResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/workitem/{workItemID}/samplers/random',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Create a QC sampling policy for a project
 */
export const createQcSamplingPolicy = <ThrowOnError extends boolean = false>(options: Options<CreateQcSamplingPolicyData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateQcSamplingPolicyResponses, CreateQcSamplingPolicyErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/qcSamplingPolicies',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get a QC sampling policy by ID
 */
export const getQcSamplingPolicy = <ThrowOnError extends boolean = false>(options: Options<GetQcSamplingPolicyData, ThrowOnError>) => {
    return (options.client ?? client).get<GetQcSamplingPolicyResponses, GetQcSamplingPolicyErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/qcSamplingPolicies/{policyID}',
        ...options
    });
};

/**
 * Update a QC sampling policy
 */
export const updateQcSamplingPolicy = <ThrowOnError extends boolean = false>(options: Options<UpdateQcSamplingPolicyData, ThrowOnError>) => {
    return (options.client ?? client).put<UpdateQcSamplingPolicyResponses, UpdateQcSamplingPolicyErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/qcSamplingPolicies/{policyID}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List service accounts for a space
 */
export const listServiceAccounts = <ThrowOnError extends boolean = false>(options: Options<ListServiceAccountsData, ThrowOnError>) => {
    return (options.client ?? client).get<ListServiceAccountsResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/service-accounts',
        ...options
    });
};

/**
 * Create a service account in a space
 */
export const createServiceAccountV2 = <ThrowOnError extends boolean = false>(options: Options<CreateServiceAccountV2Data, ThrowOnError>) => {
    return (options.client ?? client).post<CreateServiceAccountV2Responses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            },
            {
                name: 'X-API-Key',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/service-accounts',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete a service account and revoke its API key
 */
export const deleteServiceAccount = <ThrowOnError extends boolean = false>(options: Options<DeleteServiceAccountData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteServiceAccountResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/service-accounts/{serviceAccountID}',
        ...options
    });
};

/**
 * Get a specific service account
 */
export const getServiceAccount = <ThrowOnError extends boolean = false>(options: Options<GetServiceAccountData, ThrowOnError>) => {
    return (options.client ?? client).get<GetServiceAccountResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/service-accounts/{serviceAccountID}',
        ...options
    });
};

/**
 * Rotate the API key for a service account
 */
export const rotateServiceAccountApiKey = <ThrowOnError extends boolean = false>(options: Options<RotateServiceAccountApiKeyData, ThrowOnError>) => {
    return (options.client ?? client).post<RotateServiceAccountApiKeyResponses, RotateServiceAccountApiKeyErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/service-accounts/{serviceAccountID}/api-key/regenerate',
        ...options
    });
};

/**
 * Get the setting for a project
 */
export const getProjectSetting = <ThrowOnError extends boolean = false>(options: Options<GetProjectSettingData, ThrowOnError>) => {
    return (options.client ?? client).get<GetProjectSettingResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/settings',
        ...options
    });
};

/**
 * Upsert the setting for a project
 */
export const upsertProjectSetting = <ThrowOnError extends boolean = false>(options: Options<UpsertProjectSettingData, ThrowOnError>) => {
    return (options.client ?? client).put<UpsertProjectSettingResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/settings',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get a workflow setting by ID
 */
export const getProjectWorkflowSetting = <ThrowOnError extends boolean = false>(options: Options<GetProjectWorkflowSettingData, ThrowOnError>) => {
    return (options.client ?? client).get<GetProjectWorkflowSettingResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/workflows/{workflowID}/settings',
        ...options
    });
};

/**
 * Upsert a workflow setting by ID
 */
export const upsertProjectWorkflowSetting = <ThrowOnError extends boolean = false>(options: Options<UpsertProjectWorkflowSettingData, ThrowOnError>) => {
    return (options.client ?? client).put<UpsertProjectWorkflowSettingResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/workflows/{workflowID}/settings',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get the deduplication and import setting for a space
 */
export const getSpaceSetting = <ThrowOnError extends boolean = false>(options: Options<GetSpaceSettingData, ThrowOnError>) => {
    return (options.client ?? client).get<GetSpaceSettingResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/settings',
        ...options
    });
};

/**
 * Upsert the deduplication and import setting for a space
 */
export const upsertSpaceSetting = <ThrowOnError extends boolean = false>(options: Options<UpsertSpaceSettingData, ThrowOnError>) => {
    return (options.client ?? client).put<UpsertSpaceSettingResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/settings',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get SOW configuration for a project
 */
export const getSowConfig = <ThrowOnError extends boolean = false>(options: Options<GetSowConfigData, ThrowOnError>) => {
    return (options.client ?? client).get<GetSowConfigResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/sowConfig',
        ...options
    });
};

/**
 * Create SOW configuration for a project
 */
export const createSowConfig = <ThrowOnError extends boolean = false>(options: Options<CreateSowConfigData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateSowConfigResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/sowConfig',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Update SOW configuration for a project
 */
export const updateSowConfig = <ThrowOnError extends boolean = false>(options: Options<UpdateSowConfigData, ThrowOnError>) => {
    return (options.client ?? client).put<UpdateSowConfigResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/sowConfig',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get the SLA alert configuration for a SOW config and SLA type
 */
export const getSowConfigSlaAlertConfig = <ThrowOnError extends boolean = false>(options: Options<GetSowConfigSlaAlertConfigData, ThrowOnError>) => {
    return (options.client ?? client).get<GetSowConfigSlaAlertConfigResponses, GetSowConfigSlaAlertConfigErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/sowConfigs/{sowConfigID}/slaAlertConfig',
        ...options
    });
};

/**
 * Create or update the SLA alert configuration for a SOW config and SLA type
 */
export const upsertSowConfigSlaAlertConfig = <ThrowOnError extends boolean = false>(options: Options<UpsertSowConfigSlaAlertConfigData, ThrowOnError>) => {
    return (options.client ?? client).put<UpsertSowConfigSlaAlertConfigResponses, UpsertSowConfigSlaAlertConfigErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/sowConfigs/{sowConfigID}/slaAlertConfig',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List all spaces
 */
export const listSpaces = <ThrowOnError extends boolean = false>(options: Options<ListSpacesData, ThrowOnError>) => {
    return (options.client ?? client).get<ListSpacesResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/companies/{companyID}/spaces',
        ...options
    });
};

/**
 * Create a new space
 */
export const createSpace = <ThrowOnError extends boolean = false>(options: Options<CreateSpaceData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateSpaceResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/companies/{companyID}/spaces',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Soft deletes a space
 */
export const deleteSpace = <ThrowOnError extends boolean = false>(options: Options<DeleteSpaceData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteSpaceResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/companies/{companyID}/spaces/{spaceID}',
        ...options
    });
};

/**
 * Get a space by ID
 */
export const getSpaceById = <ThrowOnError extends boolean = false>(options: Options<GetSpaceByIdData, ThrowOnError>) => {
    return (options.client ?? client).get<GetSpaceByIdResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/companies/{companyID}/spaces/{spaceID}',
        ...options
    });
};

/**
 * Update a space
 */
export const updateSpace = <ThrowOnError extends boolean = false>(options: Options<UpdateSpaceData, ThrowOnError>) => {
    return (options.client ?? client).put<UpdateSpaceResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/companies/{companyID}/spaces/{spaceID}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List data splits
 */
export const listSplits = <ThrowOnError extends boolean = false>(options: Options<ListSplitsData, ThrowOnError>) => {
    return (options.client ?? client).get<ListSplitsResponses, ListSplitsErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/splits',
        ...options
    });
};

/**
 * Create a data split
 */
export const createSplit = <ThrowOnError extends boolean = false>(options: Options<CreateSplitData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateSplitResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/splits',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get a data split
 */
export const getSplit = <ThrowOnError extends boolean = false>(options: Options<GetSplitData, ThrowOnError>) => {
    return (options.client ?? client).get<GetSplitResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/splits/{splitID}',
        ...options
    });
};

/**
 * List all system taxonomies (metadata only)
 */
export const listSystemTaxonomies = <ThrowOnError extends boolean = false>(options?: Options<ListSystemTaxonomiesData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListSystemTaxonomiesResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/taxonomies',
        ...options
    });
};

/**
 * Get system taxonomy (including current version)
 */
export const getSystemTaxonomy = <ThrowOnError extends boolean = false>(options: Options<GetSystemTaxonomyData, ThrowOnError>) => {
    return (options.client ?? client).get<GetSystemTaxonomyResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/taxonomies/{taxonomyID}',
        ...options
    });
};

/**
 * List all taxonomies (metadata only)
 */
export const listTaxonomies = <ThrowOnError extends boolean = false>(options: Options<ListTaxonomiesData, ThrowOnError>) => {
    return (options.client ?? client).get<ListTaxonomiesResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/taxonomies',
        ...options
    });
};

/**
 * Create a new taxonomy (creates version 1)
 */
export const createTaxonomy = <ThrowOnError extends boolean = false>(options: Options<CreateTaxonomyData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateTaxonomyResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/taxonomies',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete a taxonomy (including all its versions)
 */
export const deleteTaxonomy = <ThrowOnError extends boolean = false>(options: Options<DeleteTaxonomyData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteTaxonomyResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/taxonomies/{taxonomyID}',
        ...options
    });
};

/**
 * Get taxonomy (including current version)
 */
export const getTaxonomy = <ThrowOnError extends boolean = false>(options: Options<GetTaxonomyData, ThrowOnError>) => {
    return (options.client ?? client).get<GetTaxonomyResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/taxonomies/{taxonomyID}',
        ...options
    });
};

/**
 * Update taxonomy (metadata only)
 */
export const updateTaxonomy = <ThrowOnError extends boolean = false>(options: Options<UpdateTaxonomyData, ThrowOnError>) => {
    return (options.client ?? client).put<UpdateTaxonomyResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/taxonomies/{taxonomyID}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List all taxonomy versions (metadata only)
 */
export const listTaxonomyVersions = <ThrowOnError extends boolean = false>(options: Options<ListTaxonomyVersionsData, ThrowOnError>) => {
    return (options.client ?? client).get<ListTaxonomyVersionsResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/taxonomies/{taxonomyID}/versions',
        ...options
    });
};

/**
 * Create a new version of an existing taxonomy
 */
export const createTaxonomyVersion = <ThrowOnError extends boolean = false>(options: Options<CreateTaxonomyVersionData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateTaxonomyVersionResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/taxonomies/{taxonomyID}/versions',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get a specific version of a taxonomy
 */
export const getTaxonomyVersion = <ThrowOnError extends boolean = false>(options: Options<GetTaxonomyVersionData, ThrowOnError>) => {
    return (options.client ?? client).get<GetTaxonomyVersionResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/taxonomies/{taxonomyID}/versions/{taxonomyVersionID}',
        ...options
    });
};

/**
 * Update taxonomy version (metadata only)
 */
export const updateTaxonomyVersion = <ThrowOnError extends boolean = false>(options: Options<UpdateTaxonomyVersionData, ThrowOnError>) => {
    return (options.client ?? client).put<UpdateTaxonomyVersionResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/taxonomies/{taxonomyID}/versions/{taxonomyVersionID}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Set this taxonomy version as the current version
 */
export const setTaxonomyVersionCurrent = <ThrowOnError extends boolean = false>(options: Options<SetTaxonomyVersionCurrentData, ThrowOnError>) => {
    return (options.client ?? client).post<SetTaxonomyVersionCurrentResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/taxonomies/{taxonomyID}/versions/{taxonomyVersionID}/set-current',
        ...options
    });
};

/**
 * List all groups in a project
 */
export const listUserGroups = <ThrowOnError extends boolean = false>(options: Options<ListUserGroupsData, ThrowOnError>) => {
    return (options.client ?? client).get<ListUserGroupsResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/groups',
        ...options
    });
};

/**
 * Create a new user group
 */
export const createUserGroup = <ThrowOnError extends boolean = false>(options: Options<CreateUserGroupData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateUserGroupResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/groups',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Update an existing user group
 */
export const updateUserGroup = <ThrowOnError extends boolean = false>(options: Options<UpdateUserGroupData, ThrowOnError>) => {
    return (options.client ?? client).put<UpdateUserGroupResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/groups/{groupID}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Bulk unassign users from a group
 */
export const bulkUnassignUsersFromGroup = <ThrowOnError extends boolean = false>(options: Options<BulkUnassignUsersFromGroupData, ThrowOnError>) => {
    return (options.client ?? client).delete<BulkUnassignUsersFromGroupResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/groups/{groupID}/members',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List all users in a group
 *
 * Returns the members of the group. Pagination is opt-in: when none of `limit`, `cursor` or `page` is supplied every matching member is returned and `meta` is omitted.
 */
export const listUserGroupMembers = <ThrowOnError extends boolean = false>(options: Options<ListUserGroupMembersData, ThrowOnError>) => {
    return (options.client ?? client).get<ListUserGroupMembersResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/groups/{groupID}/members',
        ...options
    });
};

/**
 * Assign a user to the group
 */
export const assignUserToGroup = <ThrowOnError extends boolean = false>(options: Options<AssignUserToGroupData, ThrowOnError>) => {
    return (options.client ?? client).post<AssignUserToGroupResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/groups/{groupID}/members',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Count the users in a group
 *
 * Returns the number of group members matching the given filters. Accepts the same filters as `listUserGroupMembers` so that the count reflects the currently displayed result set.
 */
export const countUserGroupMembers = <ThrowOnError extends boolean = false>(options: Options<CountUserGroupMembersData, ThrowOnError>) => {
    return (options.client ?? client).get<CountUserGroupMembersResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/groups/{groupID}/members/count',
        ...options
    });
};

/**
 * Reactivate a user in the group
 */
export const reactivateUserInGroup = <ThrowOnError extends boolean = false>(options: Options<ReactivateUserInGroupData, ThrowOnError>) => {
    return (options.client ?? client).put<ReactivateUserInGroupResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/groups/{groupID}/members/reactivate',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get user group membership
 */
export const getUserGroupMember = <ThrowOnError extends boolean = false>(options: Options<GetUserGroupMemberData, ThrowOnError>) => {
    return (options.client ?? client).get<GetUserGroupMemberResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/groups/{groupID}/members/{userID}',
        ...options
    });
};

/**
 * Update user group membership
 */
export const updateUserGroupMember = <ThrowOnError extends boolean = false>(options: Options<UpdateUserGroupMemberData, ThrowOnError>) => {
    return (options.client ?? client).put<UpdateUserGroupMemberResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/groups/{groupID}/members/{userID}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get user group membership level history
 */
export const getUserGroupMemberLevelHistory = <ThrowOnError extends boolean = false>(options: Options<GetUserGroupMemberLevelHistoryData, ThrowOnError>) => {
    return (options.client ?? client).get<GetUserGroupMemberLevelHistoryResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/groups/{groupID}/members/{userID}/levels',
        ...options
    });
};

/**
 * Adjust user skills in the group
 */
export const adjustUserGroupMemberSkill = <ThrowOnError extends boolean = false>(options: Options<AdjustUserGroupMemberSkillData, ThrowOnError>) => {
    return (options.client ?? client).post<AdjustUserGroupMemberSkillResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/groups/{groupID}/members/{userID}/adjustLevel',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List webhooks for a given project
 */
export const listWebhooks = <ThrowOnError extends boolean = false>(options: Options<ListWebhooksData, ThrowOnError>) => {
    return (options.client ?? client).get<ListWebhooksResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/webhooks',
        ...options
    });
};

/**
 * Create a new webhook for a given project
 */
export const createWebhook = <ThrowOnError extends boolean = false>(options: Options<CreateWebhookData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateWebhookResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/webhooks',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete a webhook for a given project
 */
export const deleteWebhook = <ThrowOnError extends boolean = false>(options: Options<DeleteWebhookData, ThrowOnError>) => {
    return (options.client ?? client).delete<DeleteWebhookResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/webhooks/{webhookID}',
        ...options
    });
};

/**
 * Update a webhook for a given project
 */
export const updateWebhook = <ThrowOnError extends boolean = false>(options: Options<UpdateWebhookData, ThrowOnError>) => {
    return (options.client ?? client).put<UpdateWebhookResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/webhooks/{webhookID}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get work item metadata form for a project
 */
export const getWorkItemMetadataForm = <ThrowOnError extends boolean = false>(options: Options<GetWorkItemMetadataFormData, ThrowOnError>) => {
    return (options.client ?? client).get<GetWorkItemMetadataFormResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/workItems/metadata/forms',
        ...options
    });
};

/**
 * Create a new work item metadata form for a project
 */
export const createWorkItemMetadataForm = <ThrowOnError extends boolean = false>(options: Options<CreateWorkItemMetadataFormData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateWorkItemMetadataFormResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/workItems/metadata/forms',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List all work items under a project
 */
export const listWorkItems = <ThrowOnError extends boolean = false>(options: Options<ListWorkItemsData, ThrowOnError>) => {
    return (options.client ?? client).get<ListWorkItemsResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            },
            {
                name: 'X-API-Key',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/workItems',
        ...options
    });
};

/**
 * Get work item stats under a project
 */
export const listWorkItemsStats = <ThrowOnError extends boolean = false>(options: Options<ListWorkItemsStatsData, ThrowOnError>) => {
    return (options.client ?? client).get<ListWorkItemsStatsResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/workItems/stats',
        ...options
    });
};

/**
 * Count work items under a project with optional filters
 */
export const countWorkItems = <ThrowOnError extends boolean = false>(options: Options<CountWorkItemsData, ThrowOnError>) => {
    return (options.client ?? client).get<CountWorkItemsResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            },
            {
                name: 'X-API-Key',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/workItems/count',
        ...options
    });
};

/**
 * Get inference by ID
 */
export const getWorkItemInference = <ThrowOnError extends boolean = false>(options: Options<GetWorkItemInferenceData, ThrowOnError>) => {
    return (options.client ?? client).get<GetWorkItemInferenceResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            },
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/workItems/{workItemID}/inferences/{inferenceID}',
        ...options
    });
};

/**
 * Get work item by query params
 */
export const getWorkItemsByQuery = <ThrowOnError extends boolean = false>(options?: Options<GetWorkItemsByQueryData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetWorkItemsByQueryResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            }
        ],
        url: '/v1/workItems',
        ...options
    });
};

/**
 * Get annotations by query params
 */
export const listAnnotationsByQuery = <ThrowOnError extends boolean = false>(options: Options<ListAnnotationsByQueryData, ThrowOnError>) => {
    return (options.client ?? client).get<ListAnnotationsByQueryResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/annotations',
        ...options
    });
};

/**
 * Get annotation form details by annotation ID
 */
export const getFormDetailsFromAnnotation = <ThrowOnError extends boolean = false>(options: Options<GetFormDetailsFromAnnotationData, ThrowOnError>) => {
    return (options.client ?? client).get<GetFormDetailsFromAnnotationResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/annotations/{annotationID}/formDetails',
        ...options
    });
};

/**
 * Update annotation inference details by annotation id
 */
export const updateAnnotation = <ThrowOnError extends boolean = false>(options: Options<UpdateAnnotationData, ThrowOnError>) => {
    return (options.client ?? client).put<UpdateAnnotationResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/annotations/{annotationID}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Soft-delete a work item
 */
export const internalDeleteWorkItem = <ThrowOnError extends boolean = false>(options: Options<InternalDeleteWorkItemData, ThrowOnError>) => {
    return (options.client ?? client).delete<InternalDeleteWorkItemResponses, InternalDeleteWorkItemErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/workItems/{workItemID}',
        ...options
    });
};

/**
 * Get a single work item by ID
 */
export const getWorkItem = <ThrowOnError extends boolean = false>(options: Options<GetWorkItemData, ThrowOnError>) => {
    return (options.client ?? client).get<GetWorkItemResponses, GetWorkItemErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/workItems/{workItemID}',
        ...options
    });
};

/**
 * Cancel a work item
 */
export const internalCancelWorkItem = <ThrowOnError extends boolean = false>(options: Options<InternalCancelWorkItemData, ThrowOnError>) => {
    return (options.client ?? client).post<InternalCancelWorkItemResponses, InternalCancelWorkItemErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/workItems/{workItemID}/cancel',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Reopen work item
 *
 * Creates a new iteration of work item. Supports terminal statuses (COMPLETED, FAILED, CANCELED) and active statuses (IN_PROGRESS, CLIENT_REVIEW) which will be canceled atomically before creating the new iteration.
 */
export const internalReopenWorkItem = <ThrowOnError extends boolean = false>(options: Options<InternalReopenWorkItemData, ThrowOnError>) => {
    return (options.client ?? client).post<InternalReopenWorkItemResponses, InternalReopenWorkItemErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/workItems/{workItemID}/reopen',
        ...options
    });
};

/**
 * Bulk cancel work items
 *
 * Cancels a bulk selection of work items — either an explicit list of IDs or everything matching a filter. Resolves and validates the scope synchronously and returns 202 with a job ID immediately; per-item processing happens asynchronously afterward and applies the exact same rules as single-item cancel.
 */
export const bulkCancelWorkItems = <ThrowOnError extends boolean = false>(options: Options<BulkCancelWorkItemsData, ThrowOnError>) => {
    return (options.client ?? client).post<BulkCancelWorkItemsResponses, BulkCancelWorkItemsErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/workItems/bulk/cancel',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Bulk reopen work items
 *
 * Reopens a bulk selection of work items — either an explicit list of IDs or everything matching a filter. Resolves and validates the scope synchronously and returns 202 with a job ID immediately; per-item processing happens asynchronously afterward and applies the exact same rules as single-item reopen.
 */
export const bulkReopenWorkItems = <ThrowOnError extends boolean = false>(options: Options<BulkReopenWorkItemsData, ThrowOnError>) => {
    return (options.client ?? client).post<BulkReopenWorkItemsResponses, BulkReopenWorkItemsErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/workItems/bulk/reopen',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get annotation for a work item
 *
 * Returns the annotation (including resultsUrl) for a specific work item.
 */
export const getWorkItemAnnotation = <ThrowOnError extends boolean = false>(options: Options<GetWorkItemAnnotationData, ThrowOnError>) => {
    return (options.client ?? client).get<GetWorkItemAnnotationResponses, GetWorkItemAnnotationErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            },
            {
                name: 'X-API-Key',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/workItems/{workItemID}/annotation',
        ...options
    });
};

/**
 * Get work item execution
 *
 * Returns the work item execution results
 */
export const getWorkItemExecution = <ThrowOnError extends boolean = false>(options: Options<GetWorkItemExecutionData, ThrowOnError>) => {
    return (options.client ?? client).get<GetWorkItemExecutionResponses, GetWorkItemExecutionErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/workItems/{workItemID}/execution',
        ...options
    });
};

/**
 * Create output name link for a work item
 */
export const createOutputNameLink = <ThrowOnError extends boolean = false>(options: Options<CreateOutputNameLinkData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateOutputNameLinkResponses, unknown, ThrowOnError>({
        security: [
            {
                name: 'X-API-Key',
                type: 'apiKey'
            }
        ],
        url: '/v1/projects/{projectID}/workItems/{workItemID}/output',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List all non-deleted eval expression rules for a space (active and inactive)
 */
export const listEvalExpressions = <ThrowOnError extends boolean = false>(options: Options<ListEvalExpressionsData, ThrowOnError>) => {
    return (options.client ?? client).get<ListEvalExpressionsResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/evalExpressions',
        ...options
    });
};

/**
 * Create a new QA heuristic eval expression rule for a space
 */
export const createEvalExpression = <ThrowOnError extends boolean = false>(options: Options<CreateEvalExpressionData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateEvalExpressionResponses, CreateEvalExpressionErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/evalExpressions',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get a single eval expression rule by ID
 */
export const getEvalExpression = <ThrowOnError extends boolean = false>(options: Options<GetEvalExpressionData, ThrowOnError>) => {
    return (options.client ?? client).get<GetEvalExpressionResponses, GetEvalExpressionErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/evalExpressions/{evalExpressionID}',
        ...options
    });
};

/**
 * Update an existing eval expression rule
 */
export const updateEvalExpression = <ThrowOnError extends boolean = false>(options: Options<UpdateEvalExpressionData, ThrowOnError>) => {
    return (options.client ?? client).put<UpdateEvalExpressionResponses, UpdateEvalExpressionErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/evalExpressions/{evalExpressionID}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Test/simulate an eval expression rule against sample inference data
 *
 * Evaluates an ad-hoc expression (with optional taxonomyField/severity/message) against a
 * caller-supplied sample inference payload and returns whether it would pass, plus the
 * MLError(s) that would be produced if it failed. Nothing is persisted - no eval_expression
 * or eval_error rows are created.
 *
 */
export const testEvalExpression = <ThrowOnError extends boolean = false>(options: Options<TestEvalExpressionData, ThrowOnError>) => {
    return (options.client ?? client).post<TestEvalExpressionResponses, TestEvalExpressionErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/evalExpressions/test',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List all available block types and categories (catalog)
 */
export const listBlockCatalog = <ThrowOnError extends boolean = false>(options?: Options<ListBlockCatalogData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListBlockCatalogResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/workflows/blocks',
        ...options
    });
};

/**
 * Get the active workflow for a given project
 */
export const getWorkflow = <ThrowOnError extends boolean = false>(options: Options<GetWorkflowData, ThrowOnError>) => {
    return (options.client ?? client).get<GetWorkflowResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/workflows/{workflowID}',
        ...options
    });
};

/**
 * Update a workflow
 */
export const updateWorkflow = <ThrowOnError extends boolean = false>(options: Options<UpdateWorkflowData, ThrowOnError>) => {
    return (options.client ?? client).put<UpdateWorkflowResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/workflows/{workflowID}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Update workflow definition (compile and register with orchestrator)
 *
 * Accepts a WorkflowIR, compiles it to orchestrator format, saves both representations
 * to blob storage, and registers with the orchestrator. Does not update workflow metadata
 * (name, description) in the database - use PUT /workflows/{workflowID} for that.
 *
 */
export const updateWorkflowDefinition = <ThrowOnError extends boolean = false>(options: Options<UpdateWorkflowDefinitionData, ThrowOnError>) => {
    return (options.client ?? client).put<UpdateWorkflowDefinitionResponses, UpdateWorkflowDefinitionErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/workflows/{workflowID}/definition',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List all published versions of a workflow
 *
 * Returns all published versions of the workflow in descending order (newest first).
 * Returns an empty array if the workflow has no published versions.
 *
 */
export const listWorkflowVersions = <ThrowOnError extends boolean = false>(options: Options<ListWorkflowVersionsData, ThrowOnError>) => {
    return (options.client ?? client).get<ListWorkflowVersionsResponses, ListWorkflowVersionsErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/workflows/{workflowID}/versions',
        ...options
    });
};

/**
 * Publish current workflow draft as a new immutable version
 *
 * Creates a new published version from the current draft definition. This:
 * 1. Loads the current workflow conductor definition
 * 2. Registers the workflow with Conductor orchestrator
 * 3. Creates an immutable version record in the database
 * 4. Increments the workflow's version counter
 * 5. Resets has_unpublished_changes to false
 *
 */
export const publishWorkflow = <ThrowOnError extends boolean = false>(options: Options<PublishWorkflowData, ThrowOnError>) => {
    return (options.client ?? client).post<PublishWorkflowResponses, PublishWorkflowErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/workflows/{workflowID}/versions',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get workflow definition for a specific version
 *
 * Retrieves the workflow IR (intermediate representation) for a specific version.
 * - For published versions (< latest_version): Returns the published IR
 * - For draft version (= latest_version with has_unpublished_changes=true): Returns the draft IR
 * - Returns 404 if version doesn't exist or is invalid
 *
 */
export const getWorkflowDefinitionByVersion = <ThrowOnError extends boolean = false>(options: Options<GetWorkflowDefinitionByVersionData, ThrowOnError>) => {
    return (options.client ?? client).get<GetWorkflowDefinitionByVersionResponses, GetWorkflowDefinitionByVersionErrors, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/workflows/{workflowID}/definitions/{version}',
        ...options
    });
};

/**
 * List workflows for a given space
 */
export const listWorkflows = <ThrowOnError extends boolean = false>(options: Options<ListWorkflowsData, ThrowOnError>) => {
    return (options.client ?? client).get<ListWorkflowsResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/workflows',
        ...options
    });
};

/**
 * Create a workflow for a given space
 */
export const createWorkflow = <ThrowOnError extends boolean = false>(options: Options<CreateWorkflowData, ThrowOnError>) => {
    return (options.client ?? client).post<CreateWorkflowResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/workflows',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List available workflow templates
 */
export const listWorkflowTemplates = <ThrowOnError extends boolean = false>(options?: Options<ListWorkflowTemplatesData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListWorkflowTemplatesResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/workflowTemplates',
        ...options
    });
};

/**
 * Get a workflow template by ID
 */
export const getWorkflowTemplate = <ThrowOnError extends boolean = false>(options: Options<GetWorkflowTemplateData, ThrowOnError>) => {
    return (options.client ?? client).get<GetWorkflowTemplateResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/workflowTemplates/{workflowTemplateID}',
        ...options
    });
};

/**
 * List workflow published workflows and their versions
 */
export const listAllWorkflowVersions = <ThrowOnError extends boolean = false>(options: Options<ListAllWorkflowVersionsData, ThrowOnError>) => {
    return (options.client ?? client).get<ListAllWorkflowVersionsResponses, unknown, ThrowOnError>({
        security: [
            {
                in: 'cookie',
                name: 'token',
                type: 'apiKey'
            }
        ],
        url: '/v1/spaces/{spaceID}/workflow/versions',
        ...options
    });
};
